/**
 * 中文文案(默认语言)。
 *
 * 命名约定:层级用 `.` 划分,叶子节点 value 必须是字符串(不允许嵌套字符串数组)。
 * 仅收录「跨页面会复用」「需要随语言切换」的文案,纯内部业务字符串(后端 status 枚举值)不进。
 */
export default {
  app: {
    name: 'SilkReels',
    tagline: 'AI 漫剧 · 创作 · 赛事 · 版权',
  },
  tenant: {
    suspended: {
      title: '站点已暂停服务',
      tenantLabel: '租户「{{name}}」',
      description: '当前租户已被平台停用,暂无法继续使用。如需恢复访问,请联系管理员。',
      contactTitle: '联系方式',
      phone: '客服电话',
      email: '客服邮箱',
      qrcode: '客服二维码',
      noContact: '管理员尚未配置联系方式,请通过其他渠道联系平台方。',
    },
  },
  nav: {
    home: '首页',
    works: '作品广场',
    contests: '国际赛事',
    marketplace: '交易中心',
    tasks: '任务中心',
    learning: '学习中心',
    subscription: '会员中心',
    studio: '创作中心',
  },
  studio: {
    title: '创作中心',
    pageSubtitle: '协作制片 · 编剧 · 自由创作画布',
    loginRequired: '登录后进入创作中心',
    loginRequiredHint: '创作中心需登录后使用，请先登录或注册账号。',
    featureDisabled: '创作中心模块未开通，请联系管理员',
    migrationPending: '该模块正在迁入用户端，后续 PR 开放完整功能。',
    sessionExpired: '登录已过期，请重新登录后继续',
    reenterFromPortal: '重新登录',
    backHome: '返回首页',
  },
  modeHub: {
    title: '创作中心',
    subtitle: '选择创作模式：协作制片、单人编剧或自由创作',
    back: '返回模式选择',
    enter: '进入',
    productionTitle: '制片项目',
    productionSubtitle: '团队协作 · 剧本、镜头、审片与交付全流程',
    writerTitle: '编剧工作台',
    writerSubtitle: '单人编剧 · 专注剧本创作，无协作与派工',
    creativeTitle: '自由创作',
    creativeSubtitle: '无限画布 · 可挂牌至交易中心',
  },
  pagination: {
    prev: '上一页',
    next: '下一页',
  },
  assignTask: {
    title: '派工',
    hint: '选择执行人并划派工专用额度；未派工内容对协作人只读。项目内 AI 仅扣派工额度或项目总池。',
    department: '扣款来源（部门子池）',
    departmentPool: '项目总池',
    departmentPoolHint: '不选部门时从项目总池划额度；选部门时从该部门子池划额度。',
    assignee: '执行人',
    pickMember: '选择成员',
    assigneeRequired: '请选择执行人',
    scopeItems: '派工内容',
    itemsRequired: '请从美术设定或镜头表选择至少一项内容',
    quota: '派工额度（积分）',
    quotaInvalid: '请输入有效额度',
    availableBalance: '可用余额 {{n}}',
    confirm: '确认派工',
    cancel: '取消',
    failed: '派工失败',
  },
  budget: {
    panelTitle: '项目预算与成本池',
    panelHint: 'Owner 从个人账户充值进项目总池；可划拨部门子池。部门子池≠成员派工额度，须在美术设定/镜头表「派工」并勾选具体项。',
    empty: '尚未充值项目预算',
    loadFailed: '加载预算失败',
    poolBalance: '项目总池余额',
    fundedTotal: '累计充值 {{n}}',
    fund: '充值',
    fundTitle: '充值项目预算',
    fundHint: '从您的个人账户积分划入本项目总池（不可撤销至个人账户，可收回未用部门子池）。',
    fundConfirm: '确认充值',
    fundFailed: '充值失败',
    allocateDept: '划拨部门',
    allocateTitle: '划拨部门子池',
    allocateHint: '从项目总池划入指定部门，供部门管理员向本部门成员派工。',
    allocateConfirm: '确认划拨',
    allocateFailed: '划拨失败',
    reclaim: '收回',
    reclaimPrompt: '收回至项目总池（最多 {{max}}）',
    reclaimFailed: '收回失败',
    deptPools: '部门子池',
    amount: '金额（积分）',
    amountInvalid: '请输入有效金额',
    note: '备注',
    dept: '部门',
    deptRequired: '请选择部门',
    pickDept: '选择部门',
    insufficientForAI: '项目 AI 消耗项目预算池。您是负责人时：进入「团队 → 项目预算」从个人账户充值即可，无需派工；协作成员才需要负责人派工并分配额度',
    availableBalance: '项目总池可用 {{n}}',
    deptCol: '部门',
    deptBalanceCol: '子池余额',
    gateMissingTitle: '请先设置项目预算',
    gateMissingBody: '本项目尚未充值预算。AI 生成、派工与审片消耗将从项目预算池扣除，请先充值后再开始制作。',
    gateLowTitle: '项目预算偏低',
    gateLowBody: '当前项目总剩余额 {{balance}}，已低于预警值 {{threshold}}。请及时充值，以免影响制作。',
    gateLater: '稍后再说',
    gateGoBudget: '去项目预算',
    gateContactOwner: '请联系项目负责人充值项目预算。',
  },
  hub: {
    title: '制片项目',
    subtitle: '管理剧本、镜头、审片与交付的协作制片项目',
    emptyTitle: '还没有项目',
    empty: '创建第一个制片项目，按需邀请团队或单人完成全流程',
    createFirst: '创建第一个项目',
    create: '新建项目',
    count: '共 {{n}} 个项目',
    defaultTitle: '未命名项目 {{n}}',
    open: '进入项目',
    delete: '删除',
    edit: '编辑',
    editTitle: '编辑项目',
    editSaved: '项目资料已更新',
    editFailed: '保存失败',
    deleteConfirm: '确定删除该项目？剧本、镜头与版本将一并删除。',
    loading: '加载中…',
    loadFailed: '加载项目列表失败',
    createFailed: '项目创建失败，服务暂时不可用，请稍后重试',
    deleteFailed: '删除失败',
    updatedAt: '更新于 {{time}}',
    filterCreated: '我创建的',
    filterJoined: '我参与的',
    filterAll: '全部',
    episodeTarget: '{{n}} 集',
    myRole: '我的角色 · {{role}}',
    memberCount: '{{n}} 人',
    colTitle: '项目名称',
    colType: '类型',
    colAspect: '画幅',
    colEpisodes: '集数',
    colRole: '我的角色',
    colMembers: '成员',
    colUpdated: '更新时间',
    colActions: '操作',
  },
  production: {
    loadFailed: '项目不存在或无权访问',
    noDescription: '暂无项目说明',
    navGroup: {
      pre: '前期',
      production: '制作',
      assets: '资产',
      post: '后期',
    },
    nav: {
      backToList: '返回项目列表',
      overview: '总览',
      team: '团队',
      script: '剧本',
      bible: '美术设定',
      storyboard: '分镜板',
      shots: '镜头表',
      canvas: '画布',
      reviews: '审片中心',
      tasks: '任务看板',
      assets: '资产库',
      timeline: '时间线',
      settings: '项目设置',
    },
    projectType: {
      short_drama: '短剧',
      comic_drama: 'AI 漫剧',
      commercial: '商业广告',
      other: '其他',
    },
    stats: {
      aspect: '画幅',
      episodes: '目标集数',
      role: '我的角色',
    },
    activityTitle: '最近活动',
    activityEmpty: '暂无活动记录',
    roles: {
      director: '导演',
      writer: '编剧',
      producer: '制片',
      executive_producer: '出品',
      art_director: '美术指导',
      storyboard: '分镜',
      editor: '剪辑',
      contributor: '协作者',
    },
  },
  createModal: {
    title: '新建制片项目',
    sectionBasic: '基本信息',
    sectionStorage: '资产存储',
    sectionRole: '我的岗位',
    fieldTitle: '项目名称',
    fieldTitlePlaceholder: '例如：第一季 · 项目名',
    titleRequired: '请填写项目名称',
    fieldDescription: '项目简介',
    fieldType: '类型',
    fieldAspect: '画幅',
    fieldEpisodes: '目标集数',
    fieldEpisodesPerSeason: '每季集数',
    fieldEpisodesPerSeasonHint: '填 0 表示不分季（整项目连续编号）；需要多季时再填 12、24 等',
    fieldLocale: '默认语言',
    fieldCreatorRole: '我在项目中的角色',
    storageTenant: '租户云存储',
    storageTenantHint: '推荐 · 占用您的存储配额',
    storageCustom: '自有对象存储',
    storageCustomHint: '使用用户中心已配置的 OSS / COS',
    storageCustomReady: '将使用：{{provider}} · {{bucket}} · {{region}}',
    storageCustomMissing: '尚未配置自有对象存储。请先到用户中心完成配置，再回来创建项目。',
    storageCustomGoConfig: '去用户中心配置',
    storageLocalNote: '本地存储仅在自建部署可用，SaaS 模式不展示',
    submit: '创建项目',
    submitting: '创建中…',
  },
  overview: {
    todosTitle: '我的待办',
    todosEmpty: '暂无待办 · 可从任务看板或审片中心开始',
    todoTasks: '查看任务看板中的分工项',
    todoReviews: '处理审片中心待批准镜头',
    todoComments: '回复镜头批注与协作消息',
    progressTitle: '制作进度',
    progressEmpty: '尚无镜头，请先在镜头表添加',
    episodeTarget: '{{n}} 集目标',
    memberCount: '{{n}} 人',
    quickLinks: '快捷入口',
    shotCount: '镜头数',
    episodeApproved: '{{ep}} · 已批准 {{approved}}/{{total}}',
    storyboarded: '分镜 {{n}}/{{total}}',
    withTake: 'Take {{n}}/{{total}}',
  },
  team: {
    title: '团队',
    subtitle: '按需邀请协作成员 · 项目内制片部门编组',
    seats: '协作席位 {{used}} / {{total}}',
    seatsFull: '协作席位已满，请升级套餐或移除成员后再邀请',
    personalMode: '个人制作模式',
    invite: '邀请成员',
    departmentsTitle: '制片部门',
    treeTitle: '组织树',
    treeEmpty: '暂无成员；可新建部门或直接邀请成员。',
    treeEmptyWithCollab: '点击「新建部门」创建编组，或直接邀请成员；已购协作包即可，无需再买其他权益。',
    deptCreateTitle: '新建部门',
    deptEditTitle: '编辑部门',
    deptDescriptionLabel: '部门说明（可选）',
    deptDescriptionPlaceholder: '简要说明该部门职责',
    editDept: '编辑',
    inviteToDept: '邀请到此部门',
    deptMembersEmpty: '该部门暂无成员',
    deptDeleteBlocked: '须先移出全部成员才能删除部门',
    departmentsEmpty: '尚未创建部门；单人项目可不建部门，直接邀请成员。',
    departmentsEmptyWithCollab: '点击「新建部门」创建编组；已购协作包即可，无需再买其他权益。',
    deptNameLabel: '部门名称',
    deptNamePlaceholder: '部门名称，如编剧组',
    deptNameRequired: '请先输入部门名称',
    deptCreate: '新建部门',
    deptMemberCount: '{{count}} 名成员',
    deptCreateFailed: '创建部门失败',
    deptDeleteConfirm: '确定删除此部门？（须无成员）',
    deptDeleteFailed: '删除部门失败',
    membersTitle: '成员',
    membersEmpty: '暂无成员记录',
    deptAdmin: '部门管理员',
    remove: '移除',
    removeConfirm: '确定移除此成员？',
    removeFailed: '移除成员失败',
    loadFailed: '加载团队失败',
    costSummaryHint: '成本汇总（链路 A · 只读）',
    costSummaryReadonly: '发放入口在资产库 · 此页仅查看累计',
    costSummaryEmpty: '暂无成本发放记录',
    costSummaryTotal: '累计 {{total}} 积分',
    costByDept: '按部门',
    costByMember: '按成员',
    costByAsset: '按资产',
    makeDeptAdmin: '设部门管理员',
    revokeDeptAdmin: '取消部门管理员',
    patchMemberFailed: '更新成员失败',
    inviteTitle: '邀请成员',
    fieldRole: '制片角色',
    inviteTabSearch: '用户搜索',
    inviteTabEmail: '邮箱邀请',
    inviteTabLink: '链接邀请',
    inviteSearchPlaceholder: '搜索用户名或昵称（至少 2 字）',
    invitePickUser: '请先选择要邀请的用户',
    inviteEmailRequired: '请输入邮箱',
    inviteNoResults: '未找到匹配用户',
    inviteEmailHint: '若已配置 SMTP，系统将尝试发送邮件；无论是否送达均可复制下方链接手动转发。',
    inviteEmailSent: '邀请邮件已发送（请同时保留链接备用）',
    inviteEmailNotSent: '邮件未发送（SMTP 未配置或发送失败），请复制链接手动转发',
    inviteLinkHint: '生成一次性链接，默认 7 天有效，接受后占用协作席位。',
    inviteSendEmail: '生成邮箱邀请',
    inviteGenerateLink: '生成邀请链接',
    inviteLinkReady: '邀请链接已生成，请复制并发送',
    copyLink: '复制',
    searching: '搜索中…',
    fieldDepartment: '项目部门',
    noDepartment: '不指定部门',
    inviteEmailPlaceholder: 'name@example.com',
    inviteConfirm: '确认邀请',
    inviting: '邀请中…',
    inviteFailed: '邀请失败',
    collabRequired: '邀请成员须已购创作协作包',
    upgradeCollab: '前往会员中心购买创作协作包',
    seatsExceeded: '协作席位已满，请升级套餐或移除成员',
    ownerOnly: '仅项目 owner 可执行此操作',
    memberNotFound: '成员不存在或无法移除（不能移除项目 owner）',
    deptNotFound: '部门不存在',
    deptDeleteTitle: '删除部门',
    removeTitle: '移除成员',
    editMember: '编辑',
    editMemberTitle: '编辑成员',
    noDepartmentGroup: '未分配部门',
    deptPatchFailed: '更新部门失败',
    pendingInvitesTitle: '待接受邀请',
    inviteLinkOnly: '链接邀请',
    revokeInvite: '撤销',
    revokeInviteTitle: '撤销邀请',
    revokeInviteConfirm: '确定撤销此邀请？链接将立即失效。',
    inviteRevokeFailed: '撤销邀请失败',
    assignWork: '派工',
    tabMembers: '成员与组织',
    tabBudget: '项目预算',
    tabAssignments: '项目派工',
    assignmentsPanelTitle: '项目派工',
    assignmentsPanelHint:
      '每条派工包含执行人、专用额度与 bible/镜头具体项。部门子池只是预算来源，不会自动变成成员派工。',
    assignmentsEmpty: '暂无派工记录',
    assignmentsEmptyHint: '请前往「美术设定」或「镜头表」，对角色/场次/镜头点击「派工」，选择执行人、勾选内容项并划额度。',
    assignmentsNoScope: '（无内容项）',
    assignmentsOpenKanban: '打开任务看板',
    assignmentsLoadFailed: '加载派工失败',
    memberQuotaBadge: '{{n}} 派工额度',
    memberScopeCount: '{{count}} 项内容',
    assignmentsColAssignee: '执行人',
    assignmentsColDept: '部门',
    assignmentsColScope: '派工内容',
    assignmentsColQuota: '额度',
    assignmentsColStatus: '状态',
    assignmentsTaskCount: '{{count}} 项派工',
    assignmentKindShot: '镜头',
    assignmentKindScene: '场次',
    assignmentSceneTitle: '第 {{ep}} 集 · 第 {{scene}} 场',
    colDepartment: '部门',
    colMember: '成员',
    colRole: '角色',
    colQuota: '派工额度',
    colMemberCount: '成员数',
    colActions: '操作',
  },
  bulkAssign: {
    title: '批量派工',
    open: '批量派工',
    tabShots: '镜头 / 场次',
    selectAllTab: '全选本类',
    selectEpisode: '整集全选',
    wholeEpisode: '第 {{ep}} 集',
    episodeGroup: '按集分组',
    emptyTab: '暂无可派工内容',
    loadFailed: '加载派工内容失败',
    confirm: '确认派工（{{count}} 项）',
  },
  settings: {
    title: '项目设置',
    subtitle: '编辑元数据 · 查看存储 · 危险操作',
    sectionBasic: '基本信息',
    sectionStorage: '存储',
    sectionDanger: '危险操作',
    storageReadonly: '只读',
    storageAssets: '资产数',
    storageUsed: '已用空间',
    storageLoadFailed: '加载存储信息失败',
    storageSave: '保存存储配置',
    storageSaved: '存储配置已更新',
    storageSaveFailed: '保存存储配置失败',
    customStorageHint: '仅 custom 模式可更新凭据；secret 留空则保留原值。',
    accessKeySecret: 'Access Key Secret',
    accessKeySecretPlaceholder: '留空则不修改',
    migrateToTenantOss: '迁移到租户云存储',
    migrateConfirm:
      '将存储从 {{from}} 迁移到 {{to}}？共 {{assets}} 个资产、约 {{bytes}}，可拷贝 {{copiable}} 个本地文件。',
    migrateDone: '迁移完成：已拷贝 {{migrated}} 个，跳过 {{skipped}} 个。',
    migrateFailed: '存储迁移失败',
    storageMode: {
      tenant_oss: '租户云存储',
      custom: '自有对象存储',
      local: '本地存储',
    },
    save: '保存',
    saved: '已保存',
    saveFailed: '保存失败',
    loadFailed: '加载设置失败',
    deleteHint: '删除后剧本、镜头、资产与协作记录将一并移除。',
    delete: '删除项目',
  },
  storageConfig: {
    provider: '云厂商',
    providerAliyun: '阿里云 OSS',
    providerTencent: '腾讯云 COS',
    bucket: 'Bucket',
    region: 'Region',
    endpoint: 'Endpoint',
    accessKeyId: 'AccessKey ID',
    accessKeySecret: 'AccessKey Secret',
    secretId: 'SecretId',
    secretKey: 'SecretKey',
    publicBaseUrl: '公开访问 URL',
    publicBaseUrlPlaceholder: 'https://cdn.example.com（选填）',
    publicBaseUrlHint: '若配置了 CDN 或自定义域名请填写；留空则按 bucket + endpoint 拼接。',
    prefix: 'Object 前缀',
    prefixPlaceholder: '选填，默认使用项目 ID 子目录',
    secretKeepPlaceholder: '留空表示不修改',
    bucketRequired: '请填写 Bucket',
    regionRequired: '请填写 Region',
    endpointRequired: '请填写 Endpoint',
    accessKeyIdRequired: '请填写 AccessKey ID / SecretId',
    accessKeySecretRequired: '请填写 AccessKey Secret / SecretKey',
  },
  script: {
    title: '剧本',
    subtitle: '管理多个剧本 · 点击进入编辑器撰写',
    scriptListSubtitle: '共 {{count}} 个剧本 · 「编辑」管理资料，「编写」进入正文编辑器',
    unnamedScript: '未命名剧本 {{n}}',
    colScriptName: '剧本名称',
    colScriptType: '剧本类型',
    colScriptLocale: '语言',
    colEpisodes: '集数',
    colSummary: '简介',
    addScript: '新建剧本',
    addScriptTitle: '新建剧本',
    addScriptHint: '为项目添加一份独立剧本，可在编辑器内撰写正文与分集结构。',
    addScriptConfirm: '创建',
    addScriptFailed: '新建剧本失败',
    metaCreateHint: '填写剧本名称、封面与概括介绍；正文请在「编写」中撰写。',
    metaEditHint: '管理剧本资料（名称、封面、简介），与 Fountain 正文编辑分离。',
    metaEditTitle: '编辑剧本资料',
    metaSave: '保存资料',
    metaSaveFailed: '保存剧本资料失败',
    metaSaveAndWrite: '保存并编写',
    fieldSummary: '剧本简介',
    fieldSummaryPlaceholder: '概括性介绍：题材、主线、风格、目标受众等（非正文）',
    fieldCover: '封面',
    coverUpload: '上传封面',
    coverFromAssets: '从资产库选择',
    editMeta: '编辑',
    writeScript: '编写',
    fieldScriptTitle: '剧本名称',
    fieldScriptTitlePlaceholder: '可选，如：第一季正稿',
    fieldScriptType: '剧本类型',
    fieldScriptLocale: '语言',
    localeZhCN: '简体中文',
    localeEnUS: 'English',
    editScript: '编辑',
    deleteScript: '删除',
    deleteScriptTitle: '删除剧本',
    deleteScriptConfirm: '确定删除「{{name}}」？关联场次、修订与批注将一并移除。',
    deleteScriptFailed: '删除剧本失败',
    scriptsEmptyTitle: '尚无剧本',
    scriptsEmpty: '新建第一份剧本后进入专业编辑器撰写',
    tabWorkspace: '工作台',
    tabProduction: '制片视图',
    workspaceSubtitle: '全剧结构 · 共 {{target}} 集 · 自上而下策划与撰写',
    treeLabel: '结构',
    treeSeries: '全剧大纲',
    treeStory: '故事内容',
    editorStoryContext: '故事内容',
    storyContentHint: '写下完整故事：人物关系、情节推进、世界观细节；分集正文请在季 / 集 / 场中撰写。',
    storyContentPlaceholder: '例：\n【开端】……\n【发展】……\n【高潮】……\n【结局】……',
    saveStoryContent: '保存故事内容',
    seasonDivider: '第 {{season}} 季',
    seriesOutlineHint: '只写全剧主题、人物与主线，不要写季 / 集 / 场。分集梗概和正文在左侧各集里写。',
    seriesOutlinePlaceholder: '例：\n【Logline】一句话故事\n【主题】\n【人物】谁要什么、付出什么代价\n【主线】从哪里到哪里，中途如何翻盘\n【暗线 / 世界观】',
    treeEpisodeSection: '分集结构',
    saveSeriesOutline: '保存全剧大纲',
    seasonViewHint: '本季各集梗概与剧本进度一览；可编辑梗概或进入精修模式撰写正文。',
    episodeOutlineHint: '本集 beat / 情节点；精修模式下撰写 Fountain 正文。',
    editOutline: '编辑梗概',
    enterPolish: '进入精修',
    hasOutline: '有梗概',
    hasScript: '有正文',
    aiScopeTitle: 'AI 作用范围',
    aiScopeHint: '批量 AI 与多集导入将在下一批次开放；精修模式内仍可按场操作。',
    aiScopeSeries: '全剧：完善主题、人物与主线',
    aiScopeSeason: '一季：批量生成集梗概',
    aiScopeEpisodes: '多集：按梗概写初稿',
    aiScopeScene: '单场：扩写 / 压缩 / 润色',
    aiBatchScopeHint: '根据左侧选中节点执行批量 AI；单场润色请进入精修模式。',
    aiBatchSeriesOutline: 'AI 完善全剧大纲',
    aiBatchSeasonOutlines: 'AI 生成本季梗概',
    aiBatchSeasonScripts: 'AI 写本季初稿',
    aiBatchSeasonScriptsHint: '仅创作中、有梗概且尚无正文的集；整季一次生成。',
    aiBatchEpisodeScript: 'AI 从梗概写 {{ep}}',
    aiBatchPromptPlaceholder: '可选：补充指令（留空用默认）',
    aiBatchFailed: '批量 AI 失败',
    aiBatchNoTargets: '没有符合批量条件的集数。',
    aiBatchScopeRequired: '请先选择季或集范围再执行批量 AI。',
    aiInsufficientPoints: '积分不足，无法完成本次 AI 任务。',
    aiBatchDone: '已写入 {{count}} 项',
    aiImportDone: '已导入 {{count}} 集剧本（文稿 #{{draftId}}）',
    aiModelLabel: '文本模型',
    aiModelPlaceholder: '选择模型',
    aiModelLoading: '加载模型…',
    aiModelEmpty: '未配置文本模型，请在租户控制台 AI 中心启用并定价',
    aiModelCostHint: '单次约 {{cost}} 积分',
    aiModelCostUnit: '{{cost}} 积分',
    aiModelProbe: '测试模型（你是谁）',
    aiModelProbeFailed: '模型探针失败',
    aiModelProbeOk: '连通正常 · {{ms}} ms · 消耗 {{cost}} 积分',
    aiModelProbeCatalog: '请求模型：{{name}}',
    aiModelProbeReported: '模型自述名称：{{name}}',
    aiApplyPreviewCost: '生成预览（{{cost}} 积分）',
    aiSuggestCost: '生成建议（{{cost}} 积分）',
    workspaceMeta: '目标 {{target}} 集 · 每季 {{perSeason}} 集',
    importTitle: '导入剧本',
    importHint: '粘贴或上传 Fountain / FDX 全文；多集 Fountain 用 === EPISODE N === 分隔。',
    importPlaceholder: '=== EPISODE 1 ===\nINT. ROOM - DAY\n\n...\n\n=== EPISODE 2 ===\n...',
    importMarkerHint: 'Fountain：=== EPISODE 1 ===（不区分大小写）。FDX 单文件默认 E01。无分隔符时整稿写入 E01。',
    importChooseFile: '选择文件',
    importExtendTarget: '超出目标集数时自动扩展 episode_target',
    importPreview: '预览切分',
    importConfirm: '写入 {{count}} 集',
    importEmpty: '请先粘贴或上传剧本内容',
    importReadFailed: '读取文件失败',
    importPreviewFailed: '预览失败',
    importApplyFailed: '导入失败',
    importParsed: '识别 {{count}} 集',
    importTargetExtend: '目标集数 {{from}} → {{to}}',
    importSelectAll: '全选可导入集',
    importPreviewCol: '预览',
    importOverwrite: '将覆盖',
    hubSubtitle: '按季管理 {{target}} 集 · 每季 {{perSeason}} 集 · 点击进入全屏编辑器',
    hubSubtitleSingle: '共 {{target}} 集 · 点击进入全屏编辑器',
    hubSubtitleMulti: '共 {{target}} 集 · 每季 {{perSeason}} 集 · 点击进入全屏编辑器',
    backToList: '返回列表',
    editorSeriesContext: '全剧大纲 · 共 {{target}} 集',
    episodeTitlePlaceholder: '本集名称（可选，如：开端、转折）',
    episodeBreadcrumb: '{{season}} · 全局 {{episode}}（第 {{global}} 集）',
    seasonTitle: '第 {{season}} 季',
    seasonTab: '第 {{season}} 季 · {{count}} 集',
    seasonEpisodeCount: '共 {{count}} 集',
    colSeasonEpisode: '季集',
    colGlobalEpisode: '全局集号',
    colStatus: '状态',
    colScenes: '场数',
    colUpdated: '更新',
    colActions: '操作',
    editEpisode: '编辑剧本',
    deleteEpisode: '删除',
    deleteEpisodeTitle: '删除剧本集',
    deleteEpisodeConfirm: '确定删除 {{label}}？关联场次、修订与批注将一并移除，后续集号会自动前移。',
    deleteEpisodeFailed: '删除集失败',
    deleteEpisodeMin: '至少保留 1 集',
    addEpisode: '添加一集',
    addEpisodeTitle: '新建剧本集',
    addEpisodeHint: '将在项目末尾新增 {{label}}，可在编辑器中撰写梗概与正文。',
    addEpisodeConfirm: '确认新建',
    addEpisodeFailed: '添加集数失败',
    addSeason: '添加一季',
    addSeasonFailed: '添加季失败',
    episodesGroup: '全部集数',
    sceneUntitled: '未命名场景',
    addScene: '添加一场',
    deleteScene: '删除场次',
    deleteElement: '删除当前行',
    deleteElementHint: '删除当前行（空行时 Backspace / Delete 亦可）',
    aiGenerateTitle: '一键生成',
    aiCreateTitle: 'AI 创作',
    aiCreateHint: '输入创作要求，单次请求返回文本；请自行复制粘贴到左侧剧本编辑器对应集或场，并按需修改。',
    aiCreatePlaceholder: '例：写一场室内夜戏，女主发现关键线索…',
    aiCreateBtn: '生成',
    aiResultTitle: '生成结果',
    aiResultClear: '清空展示',
    aiResultEmpty: '生成结果将显示在此处，可复制粘贴到左侧编辑器',
    aiResultHint: '选中内容复制后粘贴到左侧编辑器。',
    aiHistory: '历史',
    aiHistorySearch: '搜索历史记录…',
    aiHistoryEmpty: '暂无匹配记录',
    aiHistoryClear: '清空',
    aiHistoryClearTitle: '清空 AI 历史',
    aiHistoryClearConfirm: '将删除本项目的全部 AI 生成记录，且不可恢复。',
    aiHistoryGenerate: '生成',
    aiHistoryProbe: '探针',
    aiHistoryKindGenerate: '生成',
    aiHistoryKindProbe: '探针',
    aiCopyResult: '复制全文',
    aiCopied: '已复制',
    aiCopyFailed: '复制失败，请手动选中复制',
    aiGenerateHint: '输入创意提示词；服务端生成标准导入文稿入库后自动导入各集（大纲/梗概仍直接写入）。每批最多 6 集；草稿集可覆盖；已定稿集跳过。',
    aiGeneratePlaceholder: '例：都市悬疑短剧，女主是法医，每集一个案件…',
    aiGenerateAll: '生成大纲 + 全剧剧本',
    aiBatchWarningsTitle: '部分步骤有警告',
    aiBatchWarningsMore: '另有 {{count}} 条警告（见 Network 响应）',
    aiBatchSkipTitle: '未写入项',
    aiBatchSkip: {
      finalized: '已定稿',
      has_body: '已有正文（未开覆盖）',
      no_outline: '无梗概',
      parse_miss: 'AI 输出未能解析',
      beyond_episode_target: '超出集数上限',
    },
    aiRefineTitle: '局部润色',
    aiRefineHint: '根据左侧选中的集或场，扩写、压缩或润色选中内容。',
    loadEpisodesFailed: '加载集列表失败',
    episodesEmptyTitle: '尚无剧本集',
    episodesEmpty: '添加第一集后进入全屏专业编辑器撰写',
    statusEmpty: '未开始',
    save: '保存',
    saveWorkingCopy: '保存工作副本',
    finalize: '定稿',
    parse: '拆场',
    statusDraft: '创作中',
    statusFinalized: 'Rev {{rev}} · 已定稿',
    finalizedBanner: '已定稿：当前编辑为工作副本，不会覆盖 Rev 快照（发布修订版见 Batch 6）',
    modeWrite: '撰写',
    modeSource: 'Fountain 源码',
    conventionCn: '国产标准',
    conventionHollywood: '好莱坞标准',
    formatSceneHeadingCn: '内景 客厅 日',
    formatSceneHeadingHollywood: 'INT. LOCATION - DAY',
    placeholderCn: '内景 客厅 日\n\n...',
    placeholderHollywood: 'INT. CAFE - DAY\n\n...',
    formatStandardHint: '保存时自动规范场标题/角色/转场；PDF 国产模式内嵌中文字体子集（需系统字体或 SILKREELS_SCRIPT_FONT_PATH）',
    sceneNav: '场次导航',
    writeHint: 'Tab 切换元素类型 · Enter 新建下一块 · 与 Fountain 源码双向同步',
    editorLabel: '剧本文本',
    placeholder: 'INT. CAFE - DAY\n\n...\n\n内景 客厅 日\n\n...',
    scenesLabel: '分解场次（{{n}}）',
    scenesEmpty: '写场景标题后自动拆场。',
    elementType: '元素类型',
    dragBlock: '拖动排序',
    undoRedoHint: '撤销 / 重做',
    sceneNo: '第 {{n}} 场',
    loadFailed: '加载剧本失败',
    invalidScript: '无效的剧本',
    episodeLoading: '加载分集…',
    saveFailed: '保存失败',
    parseFailed: '拆场失败',
    finalizeFailed: '定稿失败',
    publishRevision: '发布修订版',
    publishFailed: '发布修订版失败',
    lockRevision: '锁定此版本',
    lockFailed: '锁定失败',
    lockedRev: '已锁定 Rev {{rev}}',
    tabAi: 'AI',
    tabNotes: '批注',
    tabVersions: '版本',
    aiDraftHint: '创作态：AI 可直接写入稿面（扣积分）',
    aiFinalizedHint: '修订态：AI 仅生成建议，采纳后需保存并发布修订版',
    aiPromptPlaceholder: '例：润色当前对白 / 压缩第二场动作描写…',
    aiApply: '应用至稿面',
    aiSuggest: '生成建议',
    aiFailed: 'AI 辅助失败',
    aiCurrentElement: '当前元素',
    aiEmptyElement: '当前元素为空，可直接输入指令生成内容。',
    aiQuickPolish: '一键润色当前元素',
    aiApplied: 'AI 已写入稿面',
    aiAdopted: '建议已采纳到工作副本',
    aiSuggestionTitle: 'AI 建议',
    aiUndone: '已撤销 AI 修改',
    aiPreviewTitle: 'AI 预览',
    aiPreviewBefore: '修改前',
    aiPreviewAfter: '修改后',
    aiPreviewEmpty: '（空）',
    aiPreviewConfirm: '确认写入',
    aiPreviewCancel: '取消',
    aiUndo: '撤销 AI 修改',
    aiCurrentScene: '当前第 {{n}} 场',
    aiSceneExpand: '扩写当前场',
    aiSceneCompress: '压缩当前场',
    aiSceneNext: '生成下一场',
    tabOutline: '大纲',
    outlineHint: '本集 beat / 情节点摘要；Agent 写作时会带上全剧大纲与上一集上下文。',
    episodeOutlineLabel: '本集梗概',
    outlinePlaceholder: '例：\n1. 钩子：主角发现匿名信\n2. 冲突：队友隐瞒真相\n3. 反转：信来自未来自己\n4. 悬念：门外敲门声',
    saveOutline: '保存大纲',
    prevEpisode: '上一集',
    nextEpisode: '下一集',
    autoSaving: '自动保存中…',
    unsaved: '未保存',
    saved: '已保存',
    autoSaveFailed: '自动保存失败',
    aiCost: '本次消耗 {{cost}} 积分',
    adoptSuggestion: '采纳到工作副本',
    commentPlaceholder: '编剧协作批注…',
    addComment: '添加批注',
    commentFailed: '批注失败',
    commentSelectionHint: '已选中 {{n}} 字 · 添加批注将关联此段落',
    commentsEmpty: '暂无批注',
    commentsLoading: '加载批注…',
    openCommentsCount: '{{n}} 条未解决批注',
    loadMoreComments: '加载更多批注',
    jumpToAnchor: '定位到正文',
    resolveComment: '标记已解决',
    resolved: '已解决',
    noRevisions: '尚无修订版本',
    exportFountain: '导出 Fountain',
    exportPdf: '导出 PDF',
    exportFdx: '导出 FDX',
    exportFailed: '导出失败',
    breakdown: '生成镜头',
    breakdownFailed: '拆场生成镜头失败',
    breakdownDone: '已从锁定稿生成 {{created}} 个镜头草案（跳过 {{skipped}} 个已有场）',
    localeDefault: '默认',
    listingTitle: '剧本挂牌（链路 C）',
    listingHint: '锁定稿 E{{ep}} Rev {{rev}} · 创建 marketplace 草稿后跳转 mycanvas 售卖页。收益归属项目 owner。',
    listingName: '挂牌标题',
    listingPrice: '售价（积分）',
    listingSummary: '挂牌说明',
    listingConfirm: '创建草稿并前往售卖',
    listingCancel: '取消',
    listingPriceInvalid: '请输入有效售价',
    listingFailed: '创建挂牌失败',
    listingStatus: '挂牌 {{status}}',
    listScript: '挂牌售卖',
  },
  shots: {
    title: '镜头表',
    subtitle: '最小制作单元 · 状态跟踪 · 进入工作台生成',
    subtitleV2: '结构化镜头 · 分镜画面 Tab · 缺图请在镜头工作台生成',
    subtitleV3: '按剧本与季浏览剧集 · 进入分镜工作台管理镜头',
    mergeHint: '镜头列表管元数据；分镜画面 Tab 展示关键帧。缺图请进入镜头工作台生成 Take。',
    tabList: '镜头列表',
    tabFrames: '分镜画面',
    framesEmptyTitle: '暂无分镜画面',
    framesEmpty: '添加镜头后可在工作台生成 Take',
    add: '添加镜头',
    readOnlyScope: '未派工 · 只读',
    addFirst: '添加第一个镜头',
    emptyTitle: '暂无镜头',
    empty: '从镜头表开始组织 AI 生成与审片',
    workbenchEmpty: '本分镜表为空，请展开右侧「AI 拆镜」生成本场镜头，或在剧本编辑器锁定稿后「生成镜头」',
    draftHint: '完整分镜请用右侧「AI 拆镜」或剧本编辑器「生成镜头」（须先锁定稿）',
    openWorkbench: '工作台',
    openEpisodeWorkbench: '分镜工作台',
    exportCsv: '导出 CSV',
    loadFailed: '加载镜头失败',
    createFailed: '创建镜头失败',
    saveFailed: '保存镜头失败',
    deleteFailed: '删除镜头失败',
    applyFailed: '应用镜头草案失败',
    uploadFailed: '上传分镜图失败',
    attachFailed: '关联资产失败',
    assetLoadFailed: '加载资产库失败',
    backList: '返回镜头表',
    createModalTitle: '新建镜头',
    fieldScript: '剧本',
    fieldEpisode: '剧集',
    fieldScene: '场号',
    fieldStoryboardNote: '分镜备注',
    descriptionPlaceholder: '镜头画面与动作描述…',
    dialoguePlaceholder: '角色台词、旁白…',
    soundNotePlaceholder: '环境音、拟音、特效声…',
    musicNotePlaceholder: '配乐、情绪、节奏…',
    storyboardNotePlaceholder: '构图、转场、拍摄备注…',
    seasonTab: '第 {{n}} 季',
    col: {
      index: '序号',
      slug: '镜号',
      scene: '场',
      sceneHeading: '场次',
      shotSize: '景别',
      cameraAngle: '机位',
      cameraMovement: '运镜',
      frame: '分镜图',
      description: '画面',
      dialogue: '台词',
      soundNote: '音效',
      musicNote: '音乐',
      storyboardNote: '备注',
      duration: '时长',
      status: '状态',
      action: '操作',
      episode: '集号',
      episodeTitle: '集标题',
      sceneCount: '场数',
      shotCount: '镜头数',
      progress: '进度',
    },
    progressApproved: '{{approved}}/{{total}} 已定版',
    progressEmpty: '暂无镜头',
    noScriptTitle: '请先创建剧本',
    noScript: '镜头表按剧本剧集组织，请先在剧本页创建剧本文档',
    goScript: '前往剧本',
    noEpisodeTitle: '暂无剧集',
    noEpisode: '请先在剧本编辑器中撰写或导入剧集内容',
    goScriptEditor: '打开剧本编辑器',
    episodeWorkbenchTitle: '{{label}} · 分镜工作台',
    episodeWorkbenchSubtitle: '专业镜头表 · AI 辅助拆镜 · 分镜总图',
    sceneNav: '场列表',
    expandScenePanel: '展开场列表',
    collapseScenePanel: '收起场列表',
    expandAiPanel: '展开 AI 拆镜',
    collapseAiPanel: '收起 AI 拆镜',
    allScenes: '全部场次',
    noScenes: '尚未拆场，请先在剧本编辑器撰写/解析场次，再用右侧 AI 拆镜',
    openCanvasGenerate: '去画布',
    selectAllVisible: '全选当前页镜头',
    selectShot: '选择镜头 {{slug}}',
    canvasSelectRequired: '请先勾选要生成的镜头',
    canvasSelectedCount: '（{{n}}）',
    assignWork: '派工',
    assignEpisodeNoScenes: '该集尚未拆场，无法派工',
    assignScene: '场次派工',
    assignShot: '镜头派工',
    submitSceneReview: '提交本场审片',
    sceneReviewNothing: '本场暂无可提交的镜头（需已上传分镜图且未在审片中）',
    sceneStoryboardBoard: '本场故事板',
    sceneStoryboardEmpty: '上传本场故事板',
    sceneStoryboardUploadFailed: '上传本场故事板失败',
    sceneStoryboardPreview: '{{scene}} · 本场故事板',
    episodeSceneListTitle: '{{label}} · 场列表',
    episodeSceneListHint: '为各场上传或从资产库选择参考图；首张将作为本场故事板封面。',
    expandEpisodeScenes: '展开 {{label}} 场列表',
    collapseEpisodeScenes: '收起 {{label}} 场列表',
    expandingScenes: '加载场列表…',
    sceneAssetsMissing: '未配置参考资产',
    sceneReferences: '本场参考图',
    sceneUploadRef: '上传',
    scenePickFromAssets: '资产库',
    sceneShotCount: '{{count}} 个镜头',
    sceneRefsLoadFailed: '加载本场参考图失败',
    sceneRefsLinkFailed: '关联资产失败',
    sceneRefsRemoveFailed: '移除参考图失败',
    storyboardStrip: '本场分镜故事板',
    storyboardEmpty: '添加镜头并上传/生成画面后在此预览',
    view: '查看',
    viewShotTitle: '镜头详情',
    noFrameYet: '尚未上传分镜图',
    addFrame: '添加分镜图',
    replaceFrame: '更换',
    framePickerTitle: '分镜图 · {{slug}}',
    uploadFrame: '上传分镜图',
    pickAssetShort: '资产库',
    edit: '编辑',
    save: '保存',
    pickAsset: '从资产库选择 · {{slug}}',
    noAssets: '资产库暂无分镜图',
    deleteTitle: '删除镜头',
    deleteConfirm: '确定删除镜头 {{slug}}？关联 Take 将一并删除。',
    professionalTableTitle: '分镜表',
    tableRowCount: '共 {{n}} 镜',
    sceneUntitled: '未命名场',
    aiSelectScene: '选择场次',
    aiSceneScript: '本场剧本',
    aiSceneScriptPlaceholder: '请先在左侧拆场，或从剧本编辑器定稿拆场',
    aiGenerateScene: '生成本场分镜',
    aiScenePrompt:
      '你是影视剧分镜师。根据以下第 {{episodeNo}} 集第 {{sceneNo}} 场剧本，输出 JSON 数组（仅本场镜头）。每项字段：scene_no（固定 {{sceneNo}}）、shot_size（大特写/特写/中近景/中景/中全景/全景/远景/过肩/主观）、camera_angle（平/俯/仰/过肩等）、camera_movement（固定/推/拉/摇/移/跟等）、description（画面与动作）、dialogue（台词，无则空串）、sound_note（音效）、music_note（音乐）、duration_sec（默认3）、storyboard_note（构图/转场备注）。只输出 JSON。\n\n本场剧本：\n{{body}}',
    aiPanelTitle: 'AI 拆镜',
    aiDraftCount: '预览 {{n}} 条草案',
    aiApplyDrafts: '写入 {{n}} 条镜头',
    aiFailed: 'AI 拆镜失败',
    aiParseFailed: 'AI 返回格式无法解析，请重试或调整提示',
    breakdownDone: '拆场完成：新增 {{created}} 镜，跳过 {{skipped}} 镜',
    breakdownFailed: '拆场失败（须先锁定剧本修订版）',
    status: {
      draft: '草稿',
      storyboarded: '已分镜',
      in_progress: '制作中',
      review: '待审',
      approved: '已定版',
    },
  },
  storyboard: {
    title: '分镜板',
    subtitle: 'Preferred Take 缩略图 · 景别 · 分镜备注',
    empty: '请先在「镜头」中添加镜头并在工作台生成 Take',
    noPreview: '无预览',
    shotSize: '景别',
    notePlaceholder: '构图 / 运镜备注…',
    openWorkbench: '进入工作台',
    loadFailed: '加载分镜板失败',
  },
  bible: {
    title: '美术设定',
    subtitle: '角色 · 场景 · 视觉风格；供剧本 AI 与出图引用',
    subtitleV2: '维护角色/场景美术说明与项目视觉风格，AI 撰写与出图时自动引用',
    refImage: '参考图',
    refImageHint: '可上传参考图，或进入画布 AI 生成后回写',
    locationRef: '场景参考',
    uploadRef: '上传参考图',
    uploadRefFailed: '参考图上传失败',
    add: '添加',
    addEntry: '添加{{kind}}',
    delete: '删除',
    deleteCharacterConfirm: '确定删除角色「{{name}}」？',
    deleteLocationConfirm: '确定删除场景「{{name}}」？',
    deletePropConfirm: '确定删除道具「{{name}}」？',
    deleteCostumeConfirm: '确定删除服装「{{name}}」？',
    searchPlaceholder: '搜索名称…',
    emptyList: '暂无{{kind}}，点击上方添加',
    selectHint: '从左侧选择条目进行编辑',
    save: '保存',
    saved: '已保存',
    colName: '名称',
    colDescription: '说明',
    colRef: '参考图',
    colActions: '操作',
    fieldName: '名称',
    fieldDescription: '设定说明',
    fieldDescriptionPlaceholder: '外貌、性格、服装、关系等…',
    fieldLocationDescriptionPlaceholder: '环境、时段、氛围、道具等…',
    fieldPromptHint: 'AI Prompt 片段',
    fieldPromptHintPlaceholder: '生图/扩写时附加的关键词，如发型、服装色、镜头氛围…',
    newNamePlaceholder: '名称…',
    saveStyle: '保存风格',
    create: '创建',
    createAndSave: '创建入库',
    editEntry: '编辑{{kind}}',
    modalImages: '参考图片',
    modalImage: '参考图',
    modalImagesHint: '可上传多张或从资产库选择，也可留空',
    modalImageHint: '仅支持一张参考图，可从本地上传或资产库选择',
    uploadImages: '上传图片',
    uploadImage: '上传图片',
    pickFromAssets: '从资产库选择',
    pickAssetsTitle: '从资产库选择图片',
    pickAssetsSearch: '搜索资产…',
    pickAssetsEmpty: '暂无可选图片，请先在资产库上传或在画布登记',
    pickAssetsConfirm: '确认选择（{{count}}）',
    seriesOutlineRef: '全剧大纲',
    seriesOutlineEmpty: '暂无全剧大纲，可在剧本页编写',
    modalContent: '设定说明',
    nameRequired: '请填写名称',
    untitledImage: '参考图',
    createCharacter: '创建角色',
    createLocation: '创建场景',
    createProp: '创建道具',
    createCostume: '创建服装',
    createStyle: '创建视觉',
    assignWork: '派工',
    editEntryShort: '编辑',
    imagePreview: '参考图预览',
    imagePreviewCounter: '{{current}} / {{total}}',
    noImages: '暂无图片',
    noContent: '暂无说明',
    deleteStyleConfirm: '确定清空项目视觉风格？',
    deleteStyleFieldConfirm: '确定删除「{{name}}」？',
    loadFailed: '加载失败',
    saveFailed: '保存失败',
    tab: { characters: '角色', locations: '场景', props: '道具', costumes: '服装', style: '视觉风格' },
    kindCharacter: '角色',
    kindLocation: '场景',
    kindProp: '道具',
    kindCostume: '服装',
    style: {
      sectionTitle: '项目视觉风格',
      sectionHint: '全片统一的美术方向与 Prompt，镜头生成时默认引用',
      artDirection: '美术方向',
      artDirectionPlaceholder: '如：赛博朋克、水墨国风、低饱和写实…',
      colorPalette: '色板说明',
      colorPalettePlaceholder: '主色、辅色、高光与阴影倾向…',
      stylePrompt: '风格 Prompt',
      stylePromptPlaceholder: '英文或中文风格关键词，拼入 AI 生图 prompt…',
      negativePrompt: '负向 Prompt',
      negativePromptPlaceholder: '需要规避的元素，如：模糊、水印、畸形手指…',
    },
  },
  reviews: {
    title: '审片中心',
    subtitle: '待审分镜与资产（角色 / 场景 / 道具 / 服装 / 风格）· 批准 / 退回',
    backToProduction: '返回项目',
    filterLabel: '审片分类',
    filter: {
      all: '全部',
      shot: '分镜',
      character: '角色',
      location: '场景',
      prop: '道具',
      costume: '服装',
      style: '风格',
    },
    subject: {
      shot: '分镜镜头',
      character: '角色资产',
      location: '场景资产',
      prop: '道具资产',
      costume: '服装资产',
      style: '风格资产',
    },
    queueTitle: '待审队列 · {{n}}',
    noPreview: '暂无预览图',
    videoBadge: '视频',
    metaEpisode: '集数',
    metaShotSize: '景别',
    metaDuration: '时长',
    metaScene: '场/镜',
    metaAssetKind: '资产类型',
    metaSubject: '审片分类',
    openBible: '打开美术设定',
    assetReviewHint: '资产在画布「提交审片」后进入此队列；批准后将标记为就绪并可用于后续生成。',
    assetNoteTitle: '审片备注',
    assetNoteHint: '提交或退回时填写的说明',
    assetNoteEmpty: '暂无备注',
    commentsHint: '帧级批注 · 可标记已解决 · 视频支持逐帧与 In/Out 段选',
    commentsEmpty: '暂无批注',
    videoTimeline: '审片时间轴',
    videoIn: 'In',
    videoOut: 'Out',
    videoClearInOut: '清除选段',
    videoZoomIn: '放大画面',
    videoZoomOut: '缩小画面',
    videoZoomReset: '重置',
    videoCommentHint: '←/→ 逐帧 · I/O 选段 · 发送批注绑定当前帧或 In~Out 区间 · Ctrl+滚轮缩放',
    commentSegmentPlaceholder: '针对选段添加批注…',
    videoSegmentReady: '选段 {{range}}',
    videoSegmentInOnly: '已设 In {{time}} · 请设 Out 完成选段',
    videoSegmentOutOnly: '已设 Out {{time}} · 请设 In 完成选段',
    empty: '暂无审片',
    emptySelectionTitle: '未选择审片条目',
    emptySelectionHint: '从左侧队列选择一条待审内容',
    emptyPreview: '预览区 · 选择条目后显示',
    openComments: '{{n}} 条未解决批注',
    submitReview: '提交审片',
    approve: '批准定版',
    requestChanges: '退回修改',
    requestChangesConfirm: '确认退回',
    requestChangesSuccess: '已退回修改，制作方将收到通知',
    approveSuccess: '审片已通过，条目已从待审队列移除',
    decisionTitle: '审片结论',
    decisionHint: '帧级批注写完后：全部标记已解决 → 批准定版；需整体退回时点「退回修改」',
    decisionNeedsSubmit: '资产须先在画布提交审片（状态为「待审」）后才能批准或退回',
    decisionBlocked: '仍有 {{n}} 条未解决批注，请先处理或标记已解决后再批准',
    rejectDialogHint: '可补充整体说明；若留空，将自动汇总上方未解决的批注',
    rejectDialogPlaceholder: '可选：整体退回说明…',
    feedbackPlaceholder: '退回意见（必填后点「退回修改」）…',
    comments: '批注',
    commentPlaceholder: '添加批注…',
    addComment: '发送',
    commentSent: '批注已发送，团队成员将收到通知',
    resolve: '标记已解决',
    reopen: '重新打开',
    loadFailed: '加载审片队列失败',
    actionFailed: '操作失败',
  },
  tasks: {
    title: '任务中心',
    subtitle: '承接 AI 漫剧制作任务，完成交付获得积分赏金',
    empty: '暂无开放任务',
    myTasks: '我的任务',
    myTasksSubtitle: '查看承接记录、交付进度与审核反馈',
    myEmpty: '暂无承接记录',
    loginRequiredMyTasks: '登录后查看我的任务',
    loginRequiredMyTasksHint: '承接记录、交付进度与审核反馈需登录后访问。',
    loginRequiredTake: '登录后接单',
    loginRequiredTakeHint: '申请或抢单任务需先登录创作者账号。',
    guestHintTitle: '登录解锁任务接单',
    guestHint: '登录后可申请接单、提交交付并查看我的任务。',
    backToList: '任务列表',
    points: '积分',
    slotsLeft: '剩余',
    noSummary: '暂无任务简介',
    deadline: '截止 {{date}}',
    cardStatus: {
      published: '招募中',
      in_progress: '进行中',
      completed: '已完成',
      draft: '筹备中',
      cancelled: '已取消',
    },
    detail: {
      overview: '任务说明',
      requirements: '交付要求',
      mode: '接单方式',
      deadlineLabel: '截止时间',
      noDeadline: '不限',
      takeHint: '名额充足，确认后即可开始制作并提交交付。',
      myAssignment: '我的承接',
      slotsFull: '名额已满',
      slotsFullHint: '该任务接单名额已用完，可关注其他开放任务。',
    },
    reward: '赏金',
    modeApply: '申请制',
    modeOpen: '直抢',
    apply: '申请接单',
    accept: '立即接单',
    status: '状态',
    submit: '提交交付',
    pickWork: '选择已发布作品(可选)',
    externalUrl: '外链(可选)',
    upload: '上传附件',
    note: '说明',
    submitBtn: '提交',
    boardTitle: '任务看板',
    boardSubtitle: '项目内分工 · 关联镜头可选',
    subtitleDual: '内部派工 · 协作赏金 · 三条链路分离',
    tabInternal: '内部派工',
    tabBounty: '协作赏金',
    colTitle: '标题',
    colDescription: '说明',
    colReward: '赏金',
    colSlots: '席位',
    colReviewNote: '审片备注',
    bountyCreate: '新建赏金任务',
    bountyCreateTitle: '新建协作赏金',
    bountyCreateInvalid: '请填写标题并设置有效赏金',
    internalHint: '镜头/场次派工提交后进入审片中心审成片；美术设定类派工在任务看板验收。',
    assignmentColumn: {
      pending: '待开始',
      in_progress: '制作中',
      submitted: '已提交',
      approved: '已通过',
    },
    assignmentEmpty: '暂无派工',
    submitAcceptance: '提交验收',
    openReviewCenter: '去审片中心',
    approveAssignment: '验收派工',
    assignmentApproveBlocked: '请先在审片中心定版该派工范围内的全部镜头',
    scopeItem: '{{type}} · {{id}}',
    quotaRemaining: '额度 {{remaining}}/{{total}}',
    changesRequested: '需修改',
    startWork: '开始制作',
    submitReview: '提交审片',
    approve: '验收通过',
    requestChanges: '退回修改',
    reviewNotePlaceholder: '审片备注（可选）',
    loadFailed: '加载任务失败',
    createFailed: '创建任务失败',
    updateFailed: '更新任务失败',
    deleteFailed: '删除任务失败',
    deleteConfirm: '确定删除任务「{{title}}」？',
    bountyHint: '链路 B · 发布时冻结赏金积分；接单与交付走任务中心 /api/v1/tasks/:id/*；验收在本页 approve。',
    bountyTitlePlaceholder: '协作任务标题',
    bountyDescPlaceholder: '任务说明与交付要求',
    bountyReward: '赏金（积分/人）',
    bountyCreateDraft: '创建草稿',
    bountyPublish: '发布并冻结赏金',
    bountyPublishFailed: '发布协作任务失败',
    bountyCreateFailed: '创建协作任务失败',
    bountyApproveFailed: '验收失败',
    bountyEmpty: '暂无协作赏金任务',
    bountyRewardPts: '{{n}} 积分',
    bountySlots: '{{taken}}/{{total}} 席位',
    bountyAcceptHint: '已发布任务 ID {{id}} · 执行人在任务中心接单',
    bountyAssignments: '承接/验收',
    bountyNoAssignments: '暂无承接记录',
    bountyApprove: '验收通过',
    column: {
      todo: '待办',
      in_progress: '进行中',
      review: '待审',
      done: '完成',
    },
    scopeDept: '部门 · {{name}}',
    scopeShot: '镜头 · {{id}}',
    scopeScene: '场次 · {{key}}',
    scopeBible: '美术 · {{type}}',
    scopeAsset: '资产 · {{id}}',
  },
  assets: {
    title: '资产库',
    subtitle: '全项目视觉资产汇总 · 含画布未登记产出',
    manageHint: '可在此上传文件或登记外部 URL；无限画布视觉工作区待重新规划。',
    searchPlaceholder: '搜索名称或备注…',
    viewGrid: '网格视图',
    viewList: '列表视图',
    filterAllKinds: '全部类型',
    tab: {
      all: '全部',
      image: '图片',
      video: '视频',
      audio: '音频',
      other: '其他',
    },
    empty: '暂无资产',
    mediaPreview: '媒体预览',
    emptyTab: '该分类下暂无资产',
    loadFailed: '加载资产失败',
    registerFromCanvas: '登记到资产库',
    registerFailed: '登记失败',
    unregistered: '未登记',
    sourceBibleCharacter: '美术设定 · 角色',
    sourceBibleLocation: '美术设定 · 场景',
    sourceShot: '镜头 {{slug}}',
    col: { name: '名称', kind: '类型', source: '来源', tags: '标签', status: '状态', actions: '操作' },
    kind: {
      character_ref: '角色参考',
      location_ref: '场景参考',
      storyboard: '分镜图',
      take_image: '镜头静帧',
      take_video: '镜头视频',
      prop: '道具',
      costume: '服装',
      misc: '其他',
      other: '其他',
      image: '图片',
      video: '视频',
      audio: '音频',
      doc: '文档',
    },
    status: {
      draft: '制作中',
      review: '待审',
      ready: '已定版',
      archived: '已归档',
    },
    grantCost: '成本发放',
    markReady: '标记就绪',
    markReadyFailed: '标记就绪失败',
    unmarkReady: '退回草稿',
    unmarkReadyFailed: '退回草稿失败',
    archive: '归档',
    archiveFailed: '归档失败',
    audioLoadFailed: '音频无法加载，请尝试登记到资产库或重新生成',
    audioPlay: '播放',
    audioPause: '暂停',
    audioPlaybackRate: '预览语速',
    viewActive: '在用资产',
    viewArchived: '已归档 ({{count}})',
    emptyArchived: '暂无已归档资产',
    revokeListing: '取消挂牌',
    revokeListingFailed: '取消挂牌失败',
    createListing: '挂牌交易',
    listingTitle: '资产挂牌（链路 C）',
    listingHint: '创建 marketplace 草稿后跳转 mycanvas 售卖页提交审核。收益归属项目 owner。',
    listingPrice: '售价（积分）',
    listingSummary: '挂牌说明',
    listingConfirm: '创建草稿并前往售卖',
    listingCancel: '取消',
    listingPriceInvalid: '请输入有效售价',
    listingFailed: '创建挂牌失败',
    listingStatus: '挂牌 {{status}}',
    detailTitle: '资产详情',
    fieldName: '名称',
    fieldTags: '标签',
    fieldNote: '备注',
    fieldSource: '来源',
    tagPlaceholder: '输入标签后回车',
    addTag: '添加',
    saveMeta: '保存标签与备注',
    saveFailed: '保存失败',
    upload: '上传文件',
    uploadFailed: '上传失败',
    delete: '删除资产',
    deleteConfirm: '确定删除该资产？存储文件将一并移除。',
    deleteFailed: '删除失败',
    assignTaskSection: '分配制作任务',
    assignTaskTitleSuffix: '制作',
    assignTaskAssignee: '执行人',
    assignTaskPickMember: '选择成员',
    assignTaskTitle: '任务标题',
    assignTaskDesc: '任务说明',
    assignTaskDue: '截止日期（可选）',
    assignTaskSubmit: '创建内部任务',
    assignTaskAssigneeRequired: '请选择执行人',
    assignTaskSuccess: '任务已加入看板',
    assignTaskFailed: '派单失败',
    followUpAssign: '补派跟进',
    linkedTask: '已关联任务',
    linkedTaskStatus: '{{title}} · {{status}}',
  },
  timeline: {
    title: '集时间线',
    subtitle: 'Approved 镜头 · Preferred Take · 排序 · 导出 · 发布',
    episode: '集号',
    empty: '本集暂无镜头',
    exportManifest: '导出 Manifest',
    syncWorks: '同步到 Works（草稿）',
    publishWorks: '同步并发布',
    lastExport: '最近导出 {{id}}…',
    moveUp: '上移',
    moveDown: '下移',
    moveLeft: '前移',
    moveRight: '后移',
    prevClip: '上一镜',
    nextClip: '下一镜',
    trackLabel: '剪辑轨道',
    sequenceLength: '序列 {{sec}}s',
    selectClip: '点击轨道片段查看详情',
    clipIndex: '第 {{n}} / {{total}} 镜',
    dragToReorder: '拖动以调整镜头顺序',
    loadFailed: '加载时间线失败',
    reorderFailed: '重排失败',
    exportFailed: '导出失败（须全部 approved 且有媒体）',
    publishFailed: '发布失败（须至少一集可导出 manifest 且为项目 owner）',
    publishSuccess: '已同步 {{n}} 集 · work {{id}} · 状态 {{status}}',
    stats: {
      duration: '审片通过时长 {{sec}}s',
      approved: '{{n}} 个可导出镜头',
      ratio: '画幅 {{ratio}}',
      clips: '{{n}} 镜',
    },
  },
  writer: {
    nav: { script: '剧本' },
    hub: {
      title: '编剧空间',
      subtitle: '单人编剧工作区，剧本独立于制片项目',
      emptyTitle: '还没有编剧空间',
      empty: '创建第一个编剧空间，开始撰写剧本',
      createFirst: '创建第一个空间',
      create: '新建空间',
      count: '共 {{n}} 个空间',
      defaultTitle: '未命名空间 {{n}}',
      open: '进入',
      delete: '删除空间',
      deleteConfirm: '确定删除该编剧空间？所有剧本将一并删除。',
      loadFailed: '加载编剧空间失败',
      deleteFailed: '删除失败',
      colTitle: '空间名称',
      colType: '类型',
      colEpisodes: '目标集数',
      colUpdated: '更新时间',
    },
    create: {
      title: '新建编剧空间',
      submit: '创建',
      fieldTitle: '空间名称',
      fieldSummary: '简介',
      titleRequired: '请填写空间名称',
      failed: '创建失败',
    },
    script: {
      title: '编剧工作台',
      subtitle: '管理剧本文档 · 单人编剧 · 独立于制片项目',
      defaultWorkspaceTitle: '我的剧本',
      count: '共 {{n}} 份剧本',
      emptyTitle: '还没有剧本',
      empty: '创建第一份剧本文档开始写作',
      createFirst: '创建第一份剧本',
      create: '新建剧本',
      open: '编辑',
      delete: '删除剧本',
      deleteConfirm: '确定删除该剧本？所有分集内容将一并删除。',
      loadFailed: '加载剧本列表失败',
      createFailed: '创建剧本失败',
      deleteFailed: '删除失败',
      colTitle: '剧本名称',
      colEpisodes: '目标集数',
      colUpdated: '更新时间',
    },
    editor: {
      backList: '返回剧本列表',
      episodeLabel: '第 {{n}} 集',
      episodeTitle: '本集标题',
      outline: '大纲',
      body: '正文',
      loadFailed: '加载剧本失败',
      saveFailed: '保存失败',
      statusSaved: '已保存',
      statusSaving: '保存中…',
      statusDirty: '未保存',
      statusError: '保存失败',
      sidePanel: '批注 / 版本',
      aiTitle: 'AI 辅助',
      aiPlaceholder: '例：润色对白、扩写第二场…',
      aiSuggest: '生成建议',
      aiApply: '采纳到稿面',
      aiApplySeriesOutline: '写入全剧大纲',
      aiApplyStoryContent: '写入故事内容',
      aiApplyEpisodeOutline: '写入本集梗概',
      aiApplySceneList: '追加场次表到正文',
      aiApplyNextScene: '追加为新场',
      aiFailed: 'AI 辅助失败',
      agentTitle: '编剧 Agent',
      agentLayer: {
        series: '全剧大纲 · Agent',
        story: '故事内容 · Agent',
        episode: '本集梗概与场 · Agent',
      },
      agentEmpty: {
        series: '这一层只写全剧总纲：主题、人物、主线。\n不要季/集/场，不要各集梗概。点「编写全剧大纲」后发送。',
        story: '这一层只写故事内容（叙事长文）。\n没有全剧大纲也可以写，但结构可能较散。不会拆场。',
        episode: '先写本集梗概，再拆场。\n没有全剧大纲或故事内容时不能写集；没有本集梗概时不能续写下一场。',
      },
      agentRoleUser: '你',
      agentRoleAssistant: 'Agent',
      agentThinking: '思考中…',
      agentSend: '发送',
      agentInputTitle: '补充说明（可选）',
      agentInputPlaceholder: {
        series: '例：偏群像、女主从隐忍到反杀…（Ctrl+Enter 发送）',
        story: '例：从女主回乡写起，先把人物关系铺开…（Ctrl+Enter 发送）',
        episode: '例：写一场室内夜戏，女主发现关键线索…（Ctrl+Enter 发送）',
      },
      agentClearChat: '清空对话',
      agentClearChatTitle: '清空 Agent 对话',
      agentClearChatConfirm: '将删除本工位的全部 Agent 对话记录，且不可恢复。',
      agentApplyDraftOnly: '已定稿集请复制结果；采纳写入仅支持「创作中」状态。',
      agentApplySeriesOutlineMissing: '当前页面不支持写入全剧大纲。',
      agentApplyStoryContentMissing: '当前页面不支持写入故事内容。',
      agentApplyEpisodeOutlineMissing: '当前页面不支持写入本集梗概。',
      agentStoryNoOutlineHint: '还没有全剧大纲。可以先写故事，但结构可能较散；写完后建议回全剧大纲补骨架。',
      agentNeedSeriesOrStory: '还没有全剧大纲或故事内容。先写其中一层，再写本集梗概和场。',
      agentNeedEpisodeOutline: '还没有本集梗概。先写本集要完成什么，再续写下一场或生成场次表。',
      agentFinalizedHint: '已定稿：可复制 Agent 结果到工作副本，或使用「生成建议」类只读流程。',
      agentDefaultSeries: '撰写或完善全剧大纲',
      agentDefaultStory: '撰写或续写故事内容',
      agentDefaultEpisodeOutline: '撰写本集故事梗概',
      agentDefaultContinue: '按空场写下一场，并加到场次树',
      agentDefaultSceneList: '只列出本集场次标题，不要写对白',
      agentDefaultExpand: '续写下一场戏',
      agentDefaultCheck: '检查与全剧设定的一致性',
      agentSkill: {
        series_outline: '编写全剧大纲',
        story_content: '编写故事内容',
        episode_outline: '编写本集梗概',
        continue_scene: '续写下一场',
        episode_scene_list: '生成本集场次表',
        polish: '润色片段',
        expand_outline: '续写下一场',
        continuity_check: '一致性检查',
        freeform: '自由创作',
      },
    },
    import: {
      short: '导入制片',
      title: '导入到制片项目',
      subtitle: '导入当前剧本以进行剧本分析（共 {{n}} 集）',
      production: '目标制片项目',
      targetScript: '目标剧本',
      targetScriptId: '目标剧本 ID',
      scriptN: '剧本 {{n}}',
      productionRequired: '请选择制片项目',
      scriptRequired: '请选择目标剧本',
      noProductions: '暂无可导入的制片项目',
      noScripts: '该制片项目下还没有剧本，请先在制片项目中创建剧本',
      forbidden: '无权导入或编剧导入服务未就绪',
      sourceNotFound: '编剧剧本不存在或无权访问',
      scriptNotFound: '目标剧本不存在',
      submit: '导入',
      modeFork: '复制到项目',
      modeAttach: '链接到项目',
      scopeCurrent: '当前选定页',
      scopeAll: '当前全部页',
      partsTitle: '导入内容',
      partSeriesOutline: '全剧大纲',
      partStoryContent: '故事内容',
      partSeasons: '季',
      partEpisodes: '集',
      partScenes: '场',
      partImported: '已导入',
      partNoSource: '原稿无此内容',
      partsRequired: '请至少勾选一项导入内容',
      partsHint: '已导入的层仍可勾选，再次导入会覆盖草稿。',
      attachSubtitle: '将所选内容链接到制片剧本（第 {{n}} 集），分集编辑仍写回个人稿',
      attachSuccess: '已链接集：{{imported}}；跳过：{{skipped}}',
      success: '已导入集：{{imported}}；跳过：{{skipped}}',
      failed: '导入失败',
    },
    listing: {
      hint: '锁定稿 Rev {{rev}} · 创建 marketplace 草稿后跳转售卖页',
    },
  },
  creative: {
    hub: {
      title: '自由创作',
      subtitle: '无限画布工作区，独立于制片与编剧',
      emptyTitle: '还没有创作空间',
      empty: '创建第一个空间，在画布上自由探索',
      createFirst: '创建第一个空间',
      create: '新建空间',
      count: '共 {{n}} 个空间',
      defaultTitle: '未命名空间 {{n}}',
      open: '打开画布',
      delete: '删除空间',
      deleteConfirm: '确定删除该创作空间？画布内容将一并删除。',
      loadFailed: '加载创作空间失败',
      deleteFailed: '删除失败',
      colTitle: '空间名称',
      colUpdated: '更新时间',
    },
    library: {
      nav: '自由创作库',
      workspaces: '创作空间',
      assets: '资产库',
    },
    assets: {
      searchPlaceholder: '搜索文件名…',
      upload: '上传资产',
      emptyTitle: '还没有个人资产',
      empty: '上传的图片、视频、音频归入个人资产库，所有自由创作空间共用，与制片项目隔离。',
      loadFailed: '加载资产失败',
      delete: '删除',
      deleteTitle: '删除资产',
      deleteConfirm: '确定删除「{{name}}」？存储文件将一并移除。',
      deleteFailed: '删除失败',
    },
    create: {
      title: '新建创作空间',
      editTitle: '编辑创作空间',
      submit: '创建',
      saved: '空间资料已更新',
      saveFailed: '保存失败',
      fieldTitle: '空间名称',
      fieldSummary: '简介',
      titleRequired: '请填写空间名称',
      failed: '创建失败',
    },
    listing: {
      short: '挂牌',
      title: '画布挂牌',
      hint: '勾选已生成的成片作为橱窗样品后创建草稿；没有成片不能挂牌。',
      fieldClips: '橱窗成片',
      emptyClips: '画布还没有可展示的图片或视频。请先生成成片再挂牌。',
      selectAtLeastOne: '请至少选择 1 条成片作为橱窗样品',
      selectedCount: '已选 {{n}} / {{total}} 条',
      disabledHint: '当前画布版本已挂牌，请前往交易中心管理',
      fieldTitle: '挂牌标题',
      fieldPrice: '售价（积分）',
      fieldSummary: '简介（可选）',
      submit: '创建草稿并前往售卖',
      cancel: '取消',
      priceInvalid: '请输入有效售价',
      failed: '创建挂牌失败',
    },
    publish: {
      title: '选择要发布的片段',
      hint: '勾选要同步到作品的视频片段。默认仅选中每个节点的当前版本，不会把全部生成历史都发成多集。',
      empty: '暂无可发布的视频或图片，请先在画布上完成生成。',
      cancel: '取消',
      selectAtLeastOne: '请至少选择一个片段',
      selectedCount: '已选 {{n}} / {{total}}',
      mediaVideo: '视频',
      mediaImage: '图片',
      preferred: '当前版本',
    },
  },
  canvasBoards: {
    title: '画布',
    subtitle: '管理项目内的自由创作画布，每个画布独立保存节点与生成结果。',
    subtitleCount: '共 {{count}} 个画布 · 每个画布独立保存节点与生成结果',
    create: '新建画布',
    createTitle: '新建画布',
    rename: '重命名',
    renameTitle: '重命名画布',
    open: '进入画布',
    defaultBadge: '默认',
    rowHint: '自由编排 AI 生图 / 生视频工作流',
    fieldTitle: '画布名称',
    fieldTitlePlaceholder: '例如：概念探索 A',
    col: {
      title: '名称',
      updated: '更新时间',
      actions: '操作',
    },
    emptyTitle: '还没有画布',
    emptyHint: '创建第一个画布，开始自由编排 AI 生图流程。',
    loadFailed: '加载画布列表失败',
    createFailed: '创建画布失败',
    renameFailed: '重命名失败',
    deleteFailed: '删除画布失败',
    deleteTitle: '删除画布',
    deleteConfirm: '确定删除「{{name}}」？画布内的节点与生成记录将一并删除，且不可恢复。',
  },
  promptLibrary: {
    title: '提示词库',
    tabTenant: '公共库',
    tabMine: '我的库',
    allCategories: '全部',
    uncategorized: '未分类',
    copy: '复制',
    copied: '已复制到剪贴板',
    copyFailed: '复制失败',
    loadFailed: '加载失败',
    saveFailed: '保存失败',
    deleteFailed: '删除失败',
    uploadFailed: '上传失败',
    tenantEmpty: '暂无公共提示词，请联系管理员在租户控制台配置',
    mineEmpty: '还没有个人提示词，点击上方新建',
    createPrompt: '新建提示词',
    editPrompt: '编辑提示词',
    createCategory: '新建分类',
    categoryNamePlaceholder: '分类名称',
    deletePromptTitle: '删除提示词',
    deletePromptConfirm: '确定删除「{{name}}」？',
    fieldCategory: '分类',
    fieldName: '名称',
    fieldContent: '提示词',
    fieldRemark: '备注',
    fieldEffectMedia: '效果预览',
    mediaNone: '无',
    mediaImage: '效果图',
    mediaVideo: '效果视频',
    uploadEffect: '上传',
    colName: '名称',
    colPrompt: '提示词（点击展开）',
    colRemark: '备注',
    colThumb: '缩略图',
    colAction: '操作',
    applyPrompt: '复制提示词',
  },
  canvas: {
    back: '返回',
    untitled: '视觉画布',
    viewport: {
      zoomIn: '放大',
      zoomOut: '缩小',
      fitView: '适应画布',
      resetZoom: '重置为 100%',
      selectionHint: '空白处拖拽框选 · Space 按住平移 · 滚轮缩放',
    },
    minimap: {
      ariaLabel: '画布小地图，可拖拽平移、滚轮缩放、点击跳转视口',
    },
    saving: '保存中…',
    save: '保存',
    saved: '已保存',
    unsaved: '未保存',
    saveFailed: '保存失败',
    conflict: '冲突',
    conflictHint: '画布已在其他窗口或标签页被修改。重新加载将丢弃本地改动；覆盖保存将用当前画布替换服务器版本。',
    conflictReload: '重新加载',
    conflictReloadTitle: '重新加载画布',
    conflictReloadConfirm: '将丢弃本地未保存的改动，并从服务器拉取最新版本。确定继续？',
    conflictOverwrite: '覆盖保存',
    conflictOverwriteTitle: '覆盖服务器版本',
    conflictOverwriteConfirm: '将用当前画布覆盖服务器上的较新版本，其他窗口的改动会丢失。确定继续？',
    registerReturn: '登记并返回',
    run: '生成',
    runRunning: '生成中',
    upstream: '上游引用',
    upstreamRefs: '上游引用',
    previewEmpty: '暂无预览',
    promptPositive: '正向提示词',
    promptPositivePlaceholder: '画面描述、镜头运动、氛围…（可留空，将自动拼接上游 prompt）',
    promptNegative: '负向提示词',
    promptNegativePlaceholder: '需要规避的元素，如：模糊、水印、畸形手指…',
    characterHintPlaceholder: '面部、发型、服装一致性关键词…',
    contextEmpty: '从职能页带入或手动编辑',
    textPlaceholder: '旁白、脚本片段、说明文字…',
    textInstructionPlaceholder: '描述要生成的内容，如：写一段赛博朋克雨夜街道的场景提示词…',
    textOutputPlaceholder: '生成结果将显示在此，也可手动编辑后接下游节点',
    refNamePlaceholder: '角色 / 场景名称',
    refHintPlaceholder: '一致性关键词、风格备注…',
    refAddImage: '添加参考图',
    model: '模型',
    modelCost: '{{cost}} 积分',
    noModel: '未配置该类型模型，请在租户控制台 AI 中心启用',
    history: '历史',
    historyHint: '点击版本切换预览并定位节点；星标为定版，绿色图标为空间封面；定版或封面版本不可删除',
    historyEmpty: '暂无生成记录',
    historyAllNodes: '全部生成节点',
    historyDelete: '删除此版本',
    historyDeleteTitle: '删除历史版本',
    historyDeleteConfirm: '确定删除该生成记录？此操作不可撤销。',
    historyDeleteBlockedPreferred: '定版版本不可删除，请先切换定版',
    historyDeleteBlockedCover: '空间封面不可删除，请先更换封面',
    historySetCover: '设为空间封面',
    historyWorkspaceCover: '空间封面',
    historyCoverSet: '已设为空间封面',
    historyCoverSetFailed: '设置封面失败',
    connected: '已连接 {{n}} 上游',
    ready: '就绪',
    registerName: '资产名称',
    uploadHint: '点击上传图片 / 视频 / 音频',
    uploaded: '已上传',
    section: {
      inputs: '上游输入',
      context: '上下文',
      prompt: '提示词',
      text: '文本内容',
      instruction: '生成指令',
      negative: '负向提示词',
      model: '模型',
      params: '生成参数',
      references: '参考图',
      identity: '命名与备注',
      output: '登记信息',
      assetKind: '资产类型',
    },
    exportHint: '接入上游视频，或上传外部成片；接上音频后可合成音画',
    exportHintVideoOnly: '已接入视频。可直接采用，或再接音频后合成',
    exportEmpty: '接入视频或上传外部成片',
    exportTitle: '影片名称',
    exportTitlePlaceholder: '成片标题',
    exportUpload: '上传成片',
    exportAdopt: '采用视频',
    exportDone: '成片已就绪，可同步到作品',
    exportRunning: '正在处理成片…',
    exportCompose: '合成导出',
    registerCreativeHint: '登记输出仅用于制片项目回写资产库。自由创作请用合成导出上传或发布成片。',
    audioTrim: {
      start: '截取起点(秒)',
      end: '截取终点(秒)',
      action: '截取',
      hint: '截取当前预览音频为新上传节点（WAV）',
      nodeName: '{{name}}_截取',
    },
    dockTitle: '添加节点',
    dockCollapse: '收起',
    dockAdd: '节点',
    dockLibrary: '资产库',
    dockLibraryHint: '上传与生成会进入资产库；从画布删除节点不会删除资产。点击条目放回画布，不要的资产请到资产库页管理。',
    dockLibraryEmpty: '暂无资产。上传素材或生成后会出现在这里。',
    dockLibraryOnCanvas: '已在画布',
    dockLibraryPlace: '放到画布',
    dockLibraryManage: '管理资产库',
    templates: '全部节点',
    groupCreate: '打组',
    groupUngroup: '解组',
    edgeDelete: '删除连线',
    groupShortcut: 'Ctrl+G 打组',
    ungroupShortcut: 'Ctrl+Shift+G 解组',
    category: {
      input: '输入',
      generate: '生成',
      output: '输出',
      container: '容器',
    },
    status: {
      idle: '待命',
      running: '生成中',
      succeeded: '成功',
      failed: '失败',
    },
    node: {
      context: '上下文',
      text: '文本',
      prompt: '提示词',
      upload: '上传素材',
      refCharacter: '角色参考',
      refScene: '场景参考',
      genImage: '图片生成',
      genVideo: '视频生成',
      genAudio: '音频合成',
      register: '登记输出',
      export: '合成导出',
      group: '分组',
    },
    audioTab: {
      dubbing: '配音',
      voiceSource: '音色来源',
      voiceSourceSystem: '系统音色',
      voiceSourceClone: '克隆',
      voiceSourceDesign: '设计',
      narration: '旁白',
      voiceClone: '克隆',
      voiceDesign: '设计',
      music: '音乐',
      promptLabel: '配音文案',
      promptLabelMusic: '曲风描述',
      promptLabelLyrics: '歌词',
      promptDubbing: '输入要朗读的旁白或对白…',
      promptSeedAudio: '描述对白、环境音与配乐，例如：清晨咖啡馆里，女声轻声说「你好」…',
      promptElevenTTS: '输入要朗读的旁白或对白（最多 5000 字）…',
      promptElevenMusic: '描述曲风、情绪、乐器与场景…',
      promptMurekaDescribe: '描述曲风、情绪与场景（最多 1024 字）…',
      promptMurekaLyrics: '输入歌词正文（最多 1024 字）…',
      promptClone: '输入要用克隆音色朗读的文案…',
      promptDesign: '输入要用设计音色朗读的文案…',
      promptMusicDescribe: '描述曲风、情绪、乐器与场景…（也可写在下方「风格」参数）',
      promptLyrics: '输入歌词正文；风格可在下方参数区填写',
      unavailable: '未配置此类模型',
      noModelForTab: '当前分类无可用模型，请切换音色来源或联系管理员',
      hintSeedAudio: 'Seed Audio 1.0：一段提示词直出对白 / 环境音 / 配乐；可连接最多 3 条参考音频',
      hintMiniMax: 'MiniMax Speech 2.8：选音色后可调语速 / 声调 / 音量，以及音高、强度、音色与音效',
      hintElevenTTS: 'Eleven V3：选择官方音色，稳定性可选活泼 / 自然 / 沉稳（上限 5000 字）',
      hintElevenMusic: 'Eleven Music V3：选择音乐时长后根据提示词生成配乐',
      hintMureka: 'Mureka V8：描述或填歌词生成歌曲；高级设置可开「纯乐器」。异步任务。',
      hintClone: '声音克隆需先复刻音色；IndexTTS 请连接参考音频',
      hintMusic: '音乐生成为异步任务，通常需 1～5 分钟',
      hintMusicDescribe: '描述生曲：填写风格/提示词后生成纯音乐或氛围曲',
      hintMusicLyrics: '歌词生曲：填写歌词后生成歌曲；风格可选',
      needRefAudio: '请连接上游参考音频节点后再生成',
      needDesignedVoice: '请填写声音设计生成的音色 ID（百炼 voice-design 创建）',
      createDesignedVoice: '根据描述创建设计音色',
      creatingDesignedVoice: '正在创建音色…',
      createDesignedVoiceFailed: '创建设计音色失败',
    },
    seedAudio: {
      preset: '语种、采样率与格式',
      advanced: '高级设置',
      promptLimitHint: '提示词最多 2000 字',
    },
    minimaxSpeech: {
      basic: '基础调节',
      voiceEffects: '音色效果调节',
      reset: '一键重置',
      advancedToggle: '展开/收起调节区',
      promptLimitHint: '提示词最多 50000 字',
      modifyPitchHint: '音高：负值更沉，正值更亮',
      modifyIntensityHint: '强度：负值更柔，正值更有力',
      modifyTimbreHint: '音色：负值更厚实，正值更清亮',
    },
    minimaxVoiceLib: {
      title: '音色选择',
      tabLibrary: '音色库',
      tabMine: '我的音色',
      tabFavorites: '收藏音色',
      searchPlaceholder: '搜索音色库',
      select: '选择',
      selected: '已选',
      favorite: '收藏',
      empty: '没有匹配的音色',
      mineEmpty: '克隆音色需先在 MiniMax 控制台创建；接入 API 后将在此展示。',
      genderMale: '男',
      genderFemale: '女',
      pageSize: '{{count}} 条/页',
      total: '共 {{count}} 条',
    },
    murekaMusic: {
      modeTitle: '生成模式',
      advanced: '高级设置',
      promptLimitHint: '提示词最多 1024 字',
    },
    registerKind: {
      characterRef: '角色参考',
      locationRef: '场景参考',
      storyboard: '分镜帧',
      takeVideo: 'Take 视频',
      prop: '道具',
      costume: '服装',
      misc: '其他',
    },
    params: {
      batchCount: '生成张数',
      batch1: '1 张',
      batch2: '2 张',
      batch4: '4 张',
      aspect: '画幅',
      aspect916: '9:16',
      aspect169: '16:9',
      aspect11: '1:1',
      aspect43: '4:3',
      aspect34: '3:4',
      resolution: '分辨率',
      more: '更多参数',
      expand: '展开',
      collapse: '收起',
      steps: '步数',
      cfg: '引导系数',
      seed: '随机种子',
      strength: '重绘强度',
      denoise: '降噪',
      controlnet: 'ControlNet',
      cnNone: '关闭',
      cnCanny: 'Canny 边缘',
      cnOpenpose: 'OpenPose 姿态',
      cnDepth: 'Depth 深度',
      duration: '时长',
      musicDuration: '音乐时长',
      duration30s: '30秒',
      duration1m: '1分钟',
      duration2m: '2分钟',
      duration3m: '3分钟',
      duration4m: '4分钟',
      duration3: '3 秒',
      duration5: '5 秒',
      duration10: '10 秒',
      duration15s: '15 秒',
      duration20s: '20 秒',
      duration25s: '25 秒',
      motion: '运动幅度',
      motionLow: '低',
      motionMedium: '中',
      motionHigh: '高',
      withAudio: '生成声音',
      motionStrength: '运动强度',
      fixFirstFrame: '锁定首帧',
      fixLastFrame: '锁定尾帧',
      fps: '帧率',
      yes: '是',
      no: '否',
      audioMode: '音频类型',
      audioModeTts: '语音配音',
      audioModeBgm: '背景音乐',
      audioModeSfx: '音效',
      voice: '音色',
      voiceCloneId: '克隆音色 ID',
      designedVoiceId: '设计音色 ID',
      voicePrompt: '音色描述',
      instructions: '风格指令',
      lyrics: '歌词',
      musicStyle: '音乐风格',
      musicMode: '生成模式',
      musicModeDescribe: '描述生音乐',
      musicModeLyrics: '歌词生音乐',
      instrumental: '纯乐器',
      voiceCloneEmpty: '暂无复刻音色：请先在百炼完成声音复刻，或连接参考音频（IndexTTS）',
      voiceCloneEmptyEnroll: '已连接参考音频，但仍无复刻音色列表；请确认百炼已创建克隆音色，或改用 IndexTTS 模型',
      voiceCloneWrongKind: '当前为设计音色，不能用于声音克隆；请切换到「设计」Tab，或先在百炼完成声音复刻',
      designedVoiceEmpty: '暂无设计音色，请填写音色描述后点击「创建设计音色」',
      voiceDesignWrongKind: '当前音色不是设计音色，请在「设计」Tab 创建或选择设计音色',
      language: '语种',
      langZh: '中文',
      langEn: '英文',
      sampleRate: '采样率',
      outputFormat: '输出格式',
      voiceMale: '男声',
      voiceFemale: '女声',
      voiceNarrator: '旁白',
      voiceChild: '童声',
      speed: '语速',
      pitch: '音调',
      pitchTone: '声调',
      volume: '音量',
      modifyPitch: '音高',
      modifyIntensity: '强度',
      modifyTimbre: '音色调节',
      soundEffects: '音效',
      sfxNone: '无',
      sfxSpaciousEcho: '空旷回音',
      sfxAuditorium: '礼堂广播',
      sfxTelephone: '电话失真',
      sfxRobotic: '电音',
      mmVoiceQingse: '青涩青年音色',
      mmVoiceJingying: '精英青年音色',
      mmVoiceBadao: '霸道青年音色',
      mmVoiceDaxuesheng: '青年大学生音色',
      mmVoiceShaonv: '少女音色',
      mmVoiceYujie: '御姐音色',
      mmVoiceChengshu: '成熟女性音色',
      mmVoiceTianmei: '甜美女性音色',
      mmVoicePresenterMale: '男性主持人',
      mmVoicePresenterFemale: '女性主持人',
      mmVoiceAudiobookMale: '男性有声书',
      mmVoiceAudiobookFemale: '女性有声书',
      mmVoiceCleverBoy: '聪明男童',
      mmVoiceLovelyGirl: '萌萌女童',
      stability: '稳定性',
      stabilityCreative: '活泼的',
      stabilityNatural: '自然的',
      stabilityRobust: '沉稳的',
      elVoiceSusan: 'Susan - 清晰、平静的叙述者 官方',
      elVoiceRachel: 'Rachel - 沉稳叙述 官方',
      elVoiceSarah: 'Sarah - 柔和女声 官方',
      elVoiceGeorge: 'George - 沉稳男声 官方',
      elVoiceLily: 'Lily - 清晰女声 官方',
      elVoiceCharlie: 'Charlie - 自然男声 官方',
      elVoiceBrian: 'Brian - 沉稳旁白 官方',
      elVoiceAlice: 'Alice - 清晰女声 官方',
    },
    handle: {
      roleIn: '输入',
      roleOut: '输出',
      type: {
        text: '文本',
        image: '图片',
        video: '视频',
        audio: '音频',
        ctx: '上下文',
      },
      in: {
        text: '接入文本 / 提示词，作为生成描述',
        image: '接入参考图片',
        imageMultiple: '接入参考图片（支持多连接）',
        video: '接入视频素材',
        audio: '接入参考音频',
        audioMultiple: '接入参考音频（支持多连接）',
        ctx: '接入场景上下文',
      },
      out: {
        text: '输出文本，可连至生成节点',
        image: '输出图片，可连至生成或登记',
        imageMultiple: '输出图片（可连多个下游）',
        video: '输出视频，可连至生成或合成',
        audio: '输出音频，可连至生成或合成',
        ctx: '输出场景上下文',
      },
    },
    theme: {
      openPicker: '风格',
      pickerTitle: '画布视觉风格',
      pickerSub: '选择节点布局主题与连线动效，设置会自动保存到本机',
      nodeSection: '节点风格',
      edgeSection: '连线动效',
      selected: '当前',
      node: {
        zen: { name: '禅意极简', desc: '细线框、留白、无装饰' },
        blueprint: { name: '蓝图工程', desc: '网格底纹、等宽字、工程制图感' },
        slate: { name: '板岩商务', desc: '中性灰分层、稳重卡片' },
        terminal: { name: '终端控制台', desc: '等宽绿字、黑客终端风' },
        brutal: { name: '粗野主义', desc: '粗黑框、高对比、硬阴影' },
        film: { name: '胶片场记', desc: '上下场记条、影院黑场' },
        notebook: { name: '笔记本', desc: '横线内页、左侧红线边距' },
        swiss: { name: '瑞士平面', desc: '红条标题、白底网格排版' },
        outline: { name: '线框透明', desc: '空心描边、轻透明底' },
        compact: { name: '紧凑密度', desc: '小间距、信息密度高' },
        panel: { name: '控制面板', desc: '分区标签、仪表台布局' },
        editorial: { name: '杂志编辑', desc: '衬线标题、编辑排版' },
      },
      edge: {
        solid: { name: '实线静态', desc: '无动画纯色连线' },
        flowStream: { name: '流光脉冲', desc: '推荐 · 亮色虚线高速沿路径流动' },
        flowComet: { name: '彗星拖尾', desc: '长亮段沿连线快速掠过' },
        flowNeon: { name: '霓虹双流', desc: '双色反向流动，对比最强' },
        dashFlow: { name: '虚线流动', desc: '经典虚线向前流动（已加强）' },
        dashSlow: { name: '慢速虚线', desc: '舒缓节奏' },
        dashFast: { name: '快速虚线', desc: '高频流动' },
        dashReverse: { name: '反向虚线', desc: '逆向流动' },
        dotMarch: { name: '圆点队列', desc: '圆角点状前进' },
        dotSparse: { name: '稀疏圆点', desc: '大间距点列' },
        morse: { name: '摩尔斯', desc: '长短码交替' },
        snake: { name: '长条蛇行', desc: '长段虚线爬行' },
        doubleTrack: { name: '双轨并行', desc: '主线 + 副轨反向' },
        braid: { name: '双股编织', desc: '两层交错流动' },
        rail: { name: '轨道线', desc: '中心实线 + 侧轨虚线' },
        packet: { name: '数据包', desc: '短段脉冲沿路径跑' },
        beads: { name: '串珠', desc: '多段圆点链' },
        wave: { name: '波浪', desc: '变速 dash 起伏' },
        tick: { name: '刻度', desc: '细密短划快速' },
        step: { name: '阶梯', desc: '步进式跳跃' },
        gradientShift: { name: '渐变漂移', desc: '色带沿路径变化' },
        crossDash: { name: '交叉虚线', desc: '不规则段长' },
        pipe: { name: '管道', desc: '粗圆帽慢速' },
        heartbeat: { name: '心跳', desc: '透明度节律闪动' },
        lane: { name: '车道', desc: '宽中线 + 边线标记' },
      },
    },
    errors: {
      loadFailed: '加载画布失败',
      saveFailed: '保存画布失败',
      conflict: '画布已在其他地方被修改',
      generateFailed: '生成失败',
      providerUnavailable: 'AI 服务暂时不可用，请稍后重试或更换模型',
      providerMemoryOverload: 'AI 网关内存不足（当前负载过高），请稍后重试或联系管理员扩容',
      providerCpuOverload: 'AI 网关 CPU 满载（当前负载过高），请稍后重试或降低并发',
      providerRelayFailed: '网关已收到生成结果但回传失败（连接中断），系统将自动重试；若仍失败请稍后再试',
      seedAudioVoiceMismatch: 'Seed Audio 不需要 MiniMax 音色；请刷新页面后重试，或重新选择 seed-audio-1.0 模型',
      requestTimeout: '请求超时，请重试',
      pollTimeout: '生成耗时较长，前端等待已超时；任务可能仍在后台执行，请稍后刷新或重试',
      pollTimeoutAudio: '音频合成耗时较长，前端等待已超时；任务可能仍在后台执行，请稍后刷新或重试',
      videoCopyrightBlocked: '上游模型判定生成内容可能涉及版权或敏感素材，已拒绝生成；请改写提示词（避免知名 IP、地标、品牌等）后重试',
      streamNotSupported: '当前模型不支持流式文本生成，请改用普通生成',
      noPrompt: '请填写提示词或连接 Prompt 节点',
      noTextInstruction: '请填写生成指令或连接上游文本节点',
      noModel: '未配置对应类型的 AI 模型',
      noRegister: '请选择登记节点或完成生成链',
      reviewNoRegisterOutput: '请先完成生成并添加有产出的登记节点，再提交审片',
      noOutput: '尚无可用输出，请先生成',
      noImageOutput: '生成已完成但未返回图片，请重试或更换模型',
      registerFailed: '登记资产失败',
      uploadFailed: '上传失败',
      uploadNoUrl: '上传成功但未返回素材 URL',
      uploadCreativeUnsupported: '自由创作模式暂不支持上传至制片资产库',
      registerCreativeUnsupported: '自由创作模式暂不支持登记回制片项目',
      exportNeedVideo: '请先连接上游视频，或在节点内上传成片',
      exportNeedVideoAudio: '请先连接上游视频与音频节点',
      exportComposeFailed: '音画合成失败，请检查媒体地址与浏览器支持',
      audioTrimNoSource: '当前节点没有可截取的音频预览',
      audioTrimFailed: '音频截取失败',
    },
    openFromBible: '画布生成参考图',
    openFromShot: '画布生成分镜',
    openFromWorkbench: '高级画布',
    workbenchDupTitle: '部分上下文已存在',
    workbenchDupMessage: '当前勾选镜头在本场画布中已有合并上下文。跳过则保留已有内容；更新将用最新分镜表内容重写该上下文提示词。',
    workbenchDupReplace: '更新已有上下文',
    workbenchDupSkip: '跳过，保留已有',
    workbenchDupBatch: '同一批镜头已存在合并上下文节点',
  },
  invite: {
    title: '加入制片项目',
    subtitle: '您收到一份项目协作邀请',
    expires: '链接有效期至 {{date}}',
    accept: '接受邀请并进入项目',
    accepting: '正在接受…',
    acceptFailed: '接受邀请失败',
    loadFailed: '邀请无效或已过期',
    notFound: '邀请不存在或已失效',
    loginToAccept: '登录并接受邀请',
    loginOther: '登录其他账号',
  },
  marketplace: {
    title: '交易中心',
    subtitle: '跨租户交易剧本、资产与有版权剧集(积分结算)',
    filterAll: '全部类型',
    filterType: '挂牌类型',
    typeLicensedWork: '版权剧集',
    typeScriptProject: '剧本工程',
    typeAssetBundle: '资产包',
    typeStudioScript: 'Studio 剧本',
    typeStudioAsset: 'Studio 资产',
    typeStudioCreative: '自由创作画布',
    empty: '暂无挂牌,欢迎创作者提交上架',
    myListings: '我的挂牌',
    myPurchases: '我的购买',
    recentTrades: '最近成交',
    recentTradesCongrats: '最近成交 · 恭喜以下创作者',
    recentTradesEmpty: '暂无成交记录',
    tradeCongratsShort: '恭喜成交',
    tradeMarqueePoints: '{{points}} 积分',
    soldBadge: '恭喜成交',
    soldBadgeTimes: '成交×{{count}}',
    soldCount: '已成交 {{count}} 次',
    tradeAt: '{{title}} · {{points}} 积分',
    backCatalog: '返回目录',
    loginRequiredPurchases: '登录后查看购买记录',
    loginRequiredPurchasesHint: '购买记录与订单详情需登录后访问。',
    loginRequiredListings: '登录后管理挂牌',
    loginRequiredListingsHint: '提交与管理交易中心挂牌需先登录创作者账号。',
    loginRequiredPurchase: '登录后购买',
    loginRequiredPurchaseHint: '使用积分购买授权需先登录账号。',
    points: '积分',
    exclusive: '独家授权',
    nonExclusive: '非独家',
    buy: '积分购买',
    confirmBuyTitle: '确认购买',
    confirmBuy: '确认扣积分购买',
    confirmBuyHint: '确认后立即扣除可打赏积分，授权写入账户。',
    showcaseRequired: '该挂牌缺少封面或橱窗样品，无法成交',
    deliverable: {
      licensedWork: '购买后获得该作品的播放与授权（独家成交后仅你与作者可播）。',
      asset: '购买后获得资产包下载或导入创作中心资产库的授权。',
      script: '购买后可将剧本快照导入编剧或制片空间。',
      creative: '购买后可将画布快照与橱窗成片导入自由创作。',
      generic: '购买后获得该挂牌对应授权。',
    },
    soldOut: '独家挂牌已售出',
    soldOutHint: '该独家授权已完成成交，无法再次购买',
    purchaseOk: '购买成功,授权已写入账户',
    notFound: '挂牌不存在或已下架',
    createTitle: '提交到平台审核',
    selectWork: '选择已发布且有版权登记的作品',
    fieldTitle: '挂牌标题',
    fieldSummary: '简介(可选)',
    submitPlatform: '提交平台审核',
    selectAssets: '选择资产(可多选)',
    assetsSelected: '已选 {{count}} 项',
    assetsEmpty: '暂无资产，请先上传',
    uploadAsset: '上传资产',
    assetsRequired: '资产包至少选择 1 个资产',
    workRequired: '请选择已发布且已登记版权的作品',
    purchasesEmpty: '暂无购买记录',
    listingsEmpty: '暂无挂牌记录',
    myPurchasesSubtitle: '查看积分购买订单与授权状态',
    myListingsSubtitle: '提交与管理交易中心挂牌',
    orderStatus: '状态',
    detail: {
      price: '售价',
      license: '授权方式',
      summary: '挂牌简介',
      soldTimes: '成交次数',
      samples: '橱窗样品',
      deliverable: '购买后你将获得',
    },
    newListing: '新建挂牌',
    saveDraft: '保存草稿',
    submitReview: '提交审核',
    editListing: '编辑挂牌',
    editListingHint: '仅草稿或被驳回的挂牌可编辑',
    createListingHint: '保存为草稿，确认后再提交平台审核',
    fieldTitleRequired: '请填写挂牌标题',
    deleteListingTitle: '删除挂牌',
    deleteListingConfirm: '确认删除「{{title}}」？此操作不可恢复。',
    offlineListingTitle: '下架挂牌',
    offlineListingConfirm: '确认下架「{{title}}」？下架后买家将无法在目录中看到，可稍后重新提交审核。',
    offlineListingSuccess: '挂牌已下架',
    listingStatus: {
      draft: '草稿',
      pending_platform: '待审核',
      published: '已上架',
      sold: '已售出',
      offline: '已下架',
      rejected: '已驳回',
    },
    orderStatusLabel: {
      completed: '已完成',
      pending: '处理中',
      failed: '失败',
      cancelled: '已取消',
    },
    entitlement: {
      sectionTitle: 'Studio 授权交付',
      sectionHint: '购买 studio 剧本或自由创作画布后，可导入创作中心继续编辑。',
      ordersTitle: '购买订单',
      empty: '暂无 Studio 授权',
      emptyHint: '购买 studio_script / studio_creative 挂牌后将出现在此处。',
      importWriter: '导入编剧空间',
      importCreative: '导入自由创作',
      importProductionHint: '导入制片（创作中心）',
      openStudio: '打开创作中心',
      importOk: '已导入创作中心',
      alreadyImported: '该授权已导入',
      importForbidden: '无法导入，请确认创作中心已配置且未超出空间配额',
      statusPending: '待导入',
      statusImported: '已导入至 {{target}}',
    },
  },
  userMenu: {
    title: '个人中心',
    pointsUnit: '积分',
    dashboard: '创作者概览',
    publicProfile: '公开资料',
    security: '账号与安全',
    profile: '账号资料',
    mySpace: '我的空间',
    feedback: '反馈中心',
    myWorks: '我的作品',
    revenue: '我的收益',
    recharge: '积分充值',
    withdrawals: '提现记录',
    copyright: '版权中心',
    subscription: '会员订阅',
    storage: '对象存储',
    groups: {
      center: '账户',
      manage: '管理',
      services: '服务',
    },
  },
  auth: {
    login: '登录',
    logout: '退出登录',
    register: '注册',
    getStarted: '免费开始',
    enter: '登录 / 注册',
    currentUser: '当前用户',
    pointsBalance: '积分余额',
    close: '关闭',
    backHome: '返回首页',
    market: {
      cn: '中国大陆',
      global: '海外 / Global',
    },
    loginRequiredHint: '登录后即可使用完整功能，新用户注册即送积分。',
    loginPage: {
      title: '登录',
      tagline: '登录进入 AI 漫剧工作台',
      taglineTenant: '登录 {{name}}，开启 AI 漫剧创作',
      identifier: '用户名 / 邮箱 / 手机号',
      identifierCn: '用户名 / 手机号',
      identifierGlobal: '用户名 / 邮箱',
      password: '密码',
      passwordRequired: '请填写密码',
      submit: '登录',
      submitting: '登录中…',
      failed: '登录失败',
      invalidCredential: '账号或密码不正确',
      locked: '登录失败次数过多，账号已临时锁定',
      accountInactive: '账号未激活或已停用',
      networkError: '网络错误,请稍后重试',
      noAccount: '还没账号?',
      goRegister: '立即注册',
    },
    registerPage: {
      title: '注册 SilkReels',
      tagline: '注册即送 500 积分，开启 AI 漫剧创作',
      taglineCn: '短信验证注册，新用户获赠 500 积分',
      taglineGlobal: '邮箱注册，新用户获赠 500 积分',
      username: '用户名',
      usernameHint: '3-64 字符,仅字母数字',
      usernameRequired: '请填写用户名',
      email: '邮箱',
      emailRequired: '请填写邮箱',
      emailInvalid: '邮箱格式不正确',
      passwordRequired: '密码至少 6 位',
      emailOptional: '邮箱(可选)',
      phone: '手机号',
      phonePlaceholder: '11 位手机号',
      phoneOptional: '手机号(可选,填写后需短信验证)',
      nicknameOptional: '昵称(可选)',
      password: '密码',
      passwordHint: '8-72 字符,含字母与数字',
      confirmPassword: '确认密码',
      confirmPasswordHint: '再次输入密码',
      passwordMismatch: '两次输入的密码不一致',
      passwordPolicy: '密码至少 8 位,且须同时包含字母和数字',
      submit: '注册并登录',
      submitEnter: '注册并进入',
      submitting: '注册中…',
      failed: '注册失败',
      usernameTaken: '用户名已被占用',
      emailTaken: '邮箱已被占用',
      phoneTaken: '手机号已被占用',
      tooFrequent: '注册过于频繁，请稍后再试',
      seatLimit: '该租户席位已满，暂时无法注册',
      networkError: '网络错误,请稍后重试',
      haveAccount: '已有账号?',
      goLogin: '返回登录',
    },
    referralCode: {
      label: '推荐码(可选)',
      placeholder: '如有代理商推荐码请填写',
      invalid: '推荐码无效或不可用',
    },
    tenantInvite: {
      label: '注册邀请码',
      placeholder: '请输入管理员提供的邀请码',
      required: '请先填写正确的注册邀请码',
      invalid: '注册邀请码不正确',
    },
    passwordToggle: {
      show: '显示密码',
      hide: '隐藏密码',
    },
    methods: {
      phone: '手机号',
      password: '账号密码',
      sso: '企业 SSO',
    },
    optionalFields: {
      toggle: '更多选项(推荐码等)',
    },
    forgotPassword: {
      link: '忘记密码?',
      tagline: '通过短信验证码重置密码',
      newPassword: '新密码',
      confirmPassword: '确认新密码',
      submit: '重置密码',
      submitting: '重置中…',
      failed: '重置失败',
      passwordMismatch: '两次输入的密码不一致',
      successTitle: '密码已重置',
      successHint: '请使用新密码登录',
      unavailable: '当前站点未开启短信验证,无法通过短信重置密码',
    },
    tenant: {
      multiHint: '多租户模式 · {{name}}（{{code}}），账号与套餐按租户隔离',
    },
    sms: {
      code: '短信验证码',
      send: '获取验证码',
      sending: '发送中…',
      resendIn: '{{sec}}s 后重发',
      sendFailed: '验证码发送失败',
      providerFailed: '短信服务发送失败,请检查租户控制台「云集成」中的短信签名与模板配置',
      templateMismatch:
        '短信模板与参数不匹配:请在阿里云使用验证码类模板,变量名为 code(如「您的验证码为${code}」),并在租户控制台填写对应模板 Code',
      phoneRequired: '请先填写手机号',
      phoneInvalid: '手机号格式不正确',
      phoneNotRegistered: '该手机号未注册，无法重置密码',
      codeRequired: '请填写 6 位短信验证码',
      tooFrequent: '发送过于频繁,请稍后再试',
      dailyLimit: '今日验证码次数已用完',
    },
    email: {
      code: '邮箱验证码',
      send: '获取验证码',
      sending: '发送中…',
      resendIn: '{{sec}}s 后重发',
      sendFailed: '验证码邮件发送失败,请检查平台 SMTP 配置',
      checking: '正在查询邮箱…',
      registeredHint: '该邮箱已注册,请直接登录',
      newHint: '新邮箱,验证后将创建账号',
      codeRequired: '请填写 6 位邮箱验证码',
      invalid: '邮箱验证码错误或已失效',
      expired: '邮箱验证码已过期，请重新获取',
      tooFrequent: '发送过于频繁,请稍后再试',
      dailyLimit: '今日验证码次数已用完',
    },
    phoneOtp: {
      title: '手机号登录 / 注册',
      tagline: '验证通过即可登录;未注册手机号将自动创建账号',
      checking: '正在查询手机号…',
      registeredHint: '该手机号已注册,验证后登录',
      newHint: '新手机号,验证后将自动注册并登录',
      submit: '验证并登录',
      submitRegister: '验证并注册',
      submitEnter: '验证并进入',
      submitting: '验证中…',
      failed: '验证失败,请检查验证码',
      codeInvalid: '短信验证码错误',
      codeExpired: '短信验证码已过期，请重新获取',
      unavailable: '当前站点未开启短信登录',
    },
    captcha: {
      required: '请先完成人机验证',
      failed: '人机验证失败,请重试',
    },
    adaptive: {
      signInTagline: '输入手机号或邮箱,按提示完成登录',
      identifier: '手机号 / 邮箱 / 用户名',
      identifierPlaceholder: '手机号 / 邮箱 / 用户名',
      identifierPlaceholderPhoneFirst: '手机号 / 邮箱',
      identifierRequired: '请填写手机号、邮箱或用户名',
      usePhoneInstead: '使用手机号登录',
      useEmailInstead: '使用邮箱或用户名登录',
      ssoDivider: '或使用企业 SSO',
      ssoOidc: '企业账号登录 (OIDC)',
      ssoSaml: '企业账号登录 (SAML)',
      ssoSamlHint: 'SAML 用户请从企业 IdP 门户登录,ACS 地址见租户管理员',
    },
  },
  site: {
    footer: {
      explore: '站点导航',
      copyright: '© {{year}} {{name}}. 保留所有权利。',
    },
  },
  account: {
    publicProfile: {
      title: '公开资料',
      subtitle: '设置对外展示的头像、昵称与简介，其他用户可在你的创作者空间看到',
      previewSpace: '预览我的空间',
      avatar: '头像',
      avatarHint: '支持 JPG / PNG / WebP，最大 512KB',
      avatarUploaded: '头像已上传',
      avatarUploadFailed: '头像上传失败',
      avatarTypeError: '请选择图片文件',
      avatarSizeError: '图片不能超过 512KB',
      removeAvatar: '移除头像',
      coverTitle: '空间封面 / 生活照',
      coverHint: '宽屏横幅图，建议 21:9，最大 2MB，将展示在创作者空间顶部',
      coverEmpty: '尚未上传封面图',
      coverUpload: '上传封面',
      coverUploaded: '封面已上传',
      coverUploadFailed: '封面上传失败',
      coverSizeError: '封面图不能超过 2MB',
      removeCover: '移除封面',
      socialTitle: '社交外链',
      socialHint: 'B站、YouTube、个人站等，最多 6 条',
      socialAdd: '添加链接',
      socialEmpty: '暂无外链，可添加 B站 / YouTube / 个人站等',
      socialWebsite: '个人网站',
      socialLabelPlaceholder: '显示名称',
      socialMax: '最多 6 条外链',
      featuredTitle: '代表作',
      featuredHint: '最多选择 6 部已发布作品，将展示在创作者空间顶部',
      featuredEmpty: '暂无已发布作品，发布后可在此 pin 代表作',
      featuredMax: '最多只能选择 6 部代表作',
      nickname: '展示昵称',
      nicknamePlaceholder: '2–64 个字符，留空则显示用户名',
      usernameReadonly: '用户名不可修改',
      bio: '个人简介',
      bioPlaceholder: '介绍一下你自己和你的创作方向…',
      save: '保存资料',
      saving: '保存中…',
      saveSuccess: '公开资料已更新',
      saveFailed: '保存失败',
    },
    security: {
      title: '账号与安全',
      subtitle: '实名核验、查看登录标识，绑定或更换邮箱与手机号',
      username: '用户名',
      email: '邮箱',
      noEmail: '未绑定',
      currentPhone: '当前手机号',
      noPhone: '未绑定',
      bindEmailTitle: '绑定 / 更换邮箱',
      newEmail: '新邮箱',
      emailPlaceholder: 'name@example.com',
      bindEmailSubmit: '确认绑定',
      bindingEmail: '绑定中…',
      bindEmailSuccess: '邮箱已更新',
      bindEmailFailed: '邮箱绑定失败',
      bindTitle: '绑定 / 更换手机号',
      newPhone: '新手机号',
      phonePlaceholder: '11 位手机号',
      bindSubmit: '确认绑定',
      binding: '绑定中…',
      bindSuccess: '手机号已更新',
      bindFailed: '绑定失败',
      realnameTitle: '实名核验',
      realnameHint: '提现等资金操作可能要求已实名。当前为人工核验：只填真实姓名与证件号后四位，不收集完整证件号。国家网络身份认证（网号/网证）需机构入驻，本站尚未开通。',
      realnameStatus: '核验状态',
      realnameStatus_unverified: '未认证',
      realnameStatus_pending: '审核中',
      realnameStatus_verified: '已认证',
      realnameStatus_rejected: '未通过，可重新提交',
      realnameName: '真实姓名',
      realnameNamePlaceholder: '与证件一致的姓名',
      realnameNameRequired: '请填写真实姓名',
      realnameLast4: '证件号后四位',
      realnameLast4Placeholder: '例如 123X',
      realnameLast4Required: '请填写证件号后四位',
      realnameSubmit: '提交核验',
      realnameSubmitting: '提交中…',
      realnameSubmitSuccess: '已提交，等待管理员审核',
      realnameSubmitFailed: '实名提交失败',
      realnameNationalNidUnavailable: '国家网络身份认证尚未开通，请使用姓名与证件号后四位提交人工核验',
      realnamePendingHint: '已提交，请等待管理员审核。',
      realnameVerifiedHint: '实名已通过，提现等资金操作可继续。',
    },
    profile: {
      title: '账号资料',
      subtitle: '查看基本信息,绑定手机号',
      username: '用户名',
      email: '邮箱',
      currentPhone: '当前手机号',
      noPhone: '未绑定',
      bindTitle: '绑定 / 更换手机号',
      newPhone: '新手机号',
      phonePlaceholder: '11 位手机号',
      bindSubmit: '确认绑定',
      binding: '绑定中…',
      bindSuccess: '手机号已更新',
      bindFailed: '绑定失败',
    },
    subscriptionPanel: {
      title: '会员与协作权益',
      manage: '会员中心',
      empty: '暂无有效订阅',
      membership: '个人会员',
      team: '团队版',
      expires: '到期 {{date}}',
      teamCta: '开通团队版（含协作席位）',
    },
  },
  common: {
    loading: '加载中…',
    empty: '暂无数据',
    refresh: '刷新',
    confirm: '确认',
    cancel: '取消',
    submit: '提交',
    edit: '编辑',
    delete: '删除',
    save: '保存',
    back: '返回',
    next: '下一步',
    prev: '上一步',
    search: '搜索',
    yes: '是',
    no: '否',
    all: '全部',
    actions: '操作',
    detail: '详情',
    insufficientPoints: '积分不足',
    success: '操作成功',
    coverImageUpload: {
      replace: '更换',
      remove: '移除',
      uploaded: '上传成功',
      loadError: '图片无法加载，请重新上传',
    },
    failed: '操作失败',
    needLogin: '需要登录才能查看此页面。',
    goLogin: '去登录',
    processing: '处理中…',
    submitting: '提交中…',
    close: '关闭',
    retry: '重试',
    prevPage: '上一页',
    nextPage: '下一页',
    loadFailed: '加载失败',
    loadFailedHint: '请检查网络连接后重试',
    changeLanguage: '切换语言',
    openMenu: '打开导航菜单',
    siteNav: '站点导航',
  },
  catalog: {
    viewDetail: '查看详情',
  },
  workStatus: {
    draft: '草稿',
    pending: '待审核',
    published: '已发布',
    offline: '已下架',
    rejected: '已驳回',
  },
  dashboard: {
    title: '创作者概览',
    subtitle: '作品数据、打赏与收益一览；在创作中心发布后可在此管理',
    completeProfileTitle: '完善公开资料，让其他用户认识你',
    completeProfileHint: '设置头像、昵称与简介，他人访问你的创作者空间时会看到',
    workflow: {
      studio: '创作中心',
      steps: '发布作品 · 我的作品审核 · 作品广场展示',
    },
    nav: {
      overview: '概览',
      works: '我的作品',
      revenue: '我的收益',
      profile: '账号资料',
    },
    stats: {
      worksTotal: '作品总数',
      worksSub: '已发布 {{published}} · 草稿 {{draft}}',
      viewsTotal: '累计浏览',
      viewsSub: '点赞 {{likes}}',
      tipsTotal: '打赏总额(积分)',
      tipsSub: '共 {{count}} 笔 · {{givers}} 位支持者',
      revenueAvailable: '可用收益(积分)',
      revenueSub: '累计 {{lifetime}}',
    },
    trend: {
      title: '近 30 天趋势',
      empty30d: '近 30 天还没有任何打赏 / 收益',
      empty30dSub: '持续创作与发布，数据会在此呈现',
      tips: '打赏',
      revenue: '收益',
    },
    recentTips: '最近收到的打赏',
    recentTipsEmpty: '还没有收到打赏',
    recentTipsEmptySub: '发布作品并分享给观众，打赏会自动显示在这里',
    recentWorks: '最近更新的作品',
    recentWorksEmpty: '还没有作品',
    recentWorksEmptySub: '在创作中心完成片段后，一键发布到「我的作品」',
    createFirst: '去创作中心',
    viewAll: '全部',
    manageWorks: '管理作品',
    tipUser: '用户 #{{n}}',
    tipMeta: '作品 #{{n}}',
    workMeta: '{{status}} · 浏览 {{views}} · ♥ {{likes}}',
  },
  recharge: {
    title: '积分充值',
    subtitle: '可打赏 {{tippable}} · 促销 {{promo}}（充值入账可打赏桶，可打赏/提现/AI）',
    payMethod: '支付方式',
    pay: {
      points: '积分支付',
      channelAlipay: '支付宝',
      channelWechat: '微信支付',
      channelPayPal: 'PayPal',
    },
    priceCny: '¥{{cny}}',
    tippableHint: '入账至可打赏积分，可用于打赏、提现与 AI 消费',
    buy: '立即充值',
    scanPay: '请扫码完成支付',
    waitingPaid: '已打开支付页，完成支付后积分将自动到账',
    noChannels: '暂无可用支付渠道，请联系管理员在控制台配置支付宝/微信/PayPal，或确认本地 dev 环境已启动 backend。',
    paidSuccess: '充值成功，积分已入账',
  },
  revenue: {
    title: '我的收益',
    subtitle: '可用收益按 6 类来源分别记账,需主动兑换为积分或申请提现(M5 已接入兑换)。',
    bySource: '按来源分类',
    txTitle: '收益流水',
    txTitleFiltered: '收益流水 · {{source}}',
    txEmpty: '还没有任何收益记录。继续创作 + 发布作品,等待打赏 / 赛事奖励吧!',
    backToWorks: '我的作品',
    clearFilter: '清除筛选',
    pointsUnit: '积分',
    rowCount: '{{n}} 条',
    overview: {
      availablePoints: '可用收益(积分计)',
      availablePointsHint: '含打赏 / 赛事奖金等积分类收益',
      availableCny: '可用收益(人民币计)',
      availableCnyHint: '含广告 / 订阅 / 版权买断分成',
      sourceCount: '收益来源数',
      sourceCountHint: '/ 共 6 类来源',
    },
    withdraw: {
      title: '收益变现',
      subtitle: '把收益直接提现到银行卡 / 支付宝，或用积分换现金',
      entry: '提现 / 历史',
    },
    table: {
      time: '时间',
      source: '来源',
      points: '积分',
      amount: '金额',
      status: '状态',
      note: '备注',
      footnote: '显示前 {{shown}} 条 / 共 {{total}} 条(分页待加)',
    },
    sources: {
      ad_share: '广告分成',
      tip: '观众打赏',
      license_sale: '版权售卖',
      contest_prize: '赛事奖金',
      subscription_share: '订阅分成',
      platform_buyout: '平台买断',
    },
    status: {
      available: '可用',
      converted: '已兑积分',
      withdrawn: '已提现',
      frozen: '冻结中',
    },
    convert: {
      title: '把收益兑换成积分(1:1)',
      summary: '已选 {{count}} 笔 · 共 {{total}} 积分',
      selectAll: '全选可兑换({{n}})',
      clear: '清空选择',
      submit: '兑换为积分',
      submitting: '兑换中…',
      success: '已兑换 {{total}} 积分，当前余额 {{balance}}',
    },
  },
  subscription: {
    title: '会员中心',
    subtitle: '月 / 季 / 年套餐，每月固定积分用于 AI 创作。',
    subtitleCollab:
      '创作协作包与会员积分订阅独立：购买后在创作中心邀请成员、分配部门与协作任务；不含月度会员积分。',
    collabSeats: '{{n}} 个协作席位',
    subtitleTeam: '含协作席位，可在创作中心邀请成员加入制片项目。',
    teamSeatsActive: '含 {{n}} 个协作席位',
    teamSeatsHeading: '协作席位',
    teamSeatsUnit: '席位',
    teamSeatsHint: '项目 owner 账号生效 · 可邀请成员加入制片项目',
    teamSubscribeSuccess: '已开通「{{plan}}」团队版，返回创作中心即可邀请成员',
    collabSeatsHeading: '协作席位',
    collabSeatsUnit: '席位',
    collabSeatsHint: '项目 owner 账号生效 · 可邀请成员加入制片项目',
    collabSubscribeSuccess: '已开通「{{plan}}」协作包，返回创作中心即可邀请成员',
    returnToStudio: '返回创作中心继续邀请',
    storeSection: '选择套餐',
    audiencePersonal: '个人会员',
    audienceTeam: '团队会员',
    audienceTabTeam: '团队版会员',
    cycleMonthly: '月会员',
    cycleQuarterly: '季会员',
    cycleYearly: '年会员',
    cycleTabMonthly: '月会员',
    cycleTabQuarterly: '季会员',
    cycleTabYearly: '年会员',
    cycleQuarterlyHint: '季付更省',
    cycleYearlyHint: '年付更省',
    cycleDiscountZhe: '{{zhe}}折',
    cycleDiscountOff: '省 {{pct}}%',
    pricePeriod: {
      monthly: '/月',
      quarterly: '/季',
      yearly: '/年',
    },
    pointsPeriod: {
      monthly: '月',
      quarterly: '季',
      yearly: '年',
    },
    monthlyReset: '每月 {{n}} 积分 · 未用完次月清零',
    monthlyResetDuringPeriod: '订阅 {{months}} 个月内每月 {{n}} 积分 · 未用完次月清零',
    monthlyGrantHeading: '每月会员积分',
    pointsUnit: '积分',
    periodTotalHint: '本周期可获得',
    pointUnitYuan: '1积分={{price}}元',
    emptyPlans: '当前分类与计费周期下暂无可用套餐',
    status: {
      active: '生效中',
      expired: '已过期',
      canceled: '已取消',
    },
    memberQuota: '本月会员积分 {{n}} / {{monthly}}',
    memberQuotaShort: '本月积分 {{n}} / {{monthly}}',
    perkMonthlyPoints: '每月 {{n}} 积分（未用完次月清零）',
    perkMonthlyPointsPeriod: '订阅期内每月 {{n}} 积分（共 {{months}} 个月）',
    perkTeamSeats: '{{n}} 个创作协作席位',
    perDaysShort: '{{n}} 天',
    pointsBreakdown: '通用 {{general}} + 会员 {{bonus}}',
    teamSeats: '{{n}} 个席位',
    faqTitle: '常见问题',
    moreQuestions: '更多问题',
    contactPrefix: '联系邮箱：',
    current: '当前订阅',
    expiresAndStatus: '到期 {{date}} · 状态 {{status}} · {{auto}}',
    expiresAt: '到期 {{date}}',
    autoRenewOn: '已开启自动续订',
    autoRenewOff: '不自动续订',
    cancelAuto: '关闭自动续订',
    canceling: '处理中…',
    perDays: '积分 / {{n}} 天',
    monthly: '每月 {{n}} 积分',
    monthlyBonus: '每月 {{n}} 积分',
    subscribed: '已订阅',
    subscribe: '立即订阅',
    recommended: '推荐',
    bottomHint:
      '看完了想存收益？去 <1>我的收益</1> 把收益兑换成积分(1:1)，可立刻用于订阅。',
    revenueLink: '我的收益',
    alreadyHas: '您已经有一份激活的订阅,请先等到期或取消自动续订',
    pointsInsufficient: '积分不足,请先签到或充值',
    subscribeSuccess: '已开通「{{plan}}」会员',
    cancelSuccess: '已关闭自动续订(当前订阅仍在有效期内)',
    hasActivePlan: '当前已有订阅,到期前不可更换套餐',
    blocked: '不可订阅',
    upgrade: '升级套餐',
    cannotDowngrade: '不可降级',
    cannotSwitchCycle: '当前订阅到期后可更换计费周期或类型',
    upgradeSuccess: '已升级至「{{plan}}」,到期时间不变',
    pay: {
      title: '订阅 {{plan}}',
      upgradeTitle: '升级至 {{plan}}',
      upgradeHint: '从「{{from}}」升级,仅需补差价,到期时间不变',
      amount: '应付',
      upgradeAmount: '补差价',
      upgradeNote: '升级后保留当前订阅到期日,不重新计算周期',
      pointsAmount: '{{n}} 积分',
      cashAmount: '¥ {{n}}',
      balance: '可用积分 {{n}}（优先消耗会员月度积分）',
      balanceDetail: '通用 {{general}} · 会员 {{bonus}}',
      includesMonthly: '开通后每月重置 {{n}} 会员积分',
      method: '支付方式',
      points: '积分支付',
      channelAlipay: '支付宝',
      channelWechat: '微信支付',
      channelPayPal: 'PayPal',
      confirm: '确认支付',
      upgradeConfirm: '确认升级',
      channelUnavailable: '该支付渠道未配置,请在管理端配置支付宝/微信/PayPal 密钥,或使用积分支付。',
      noChannels: '暂无可用支付渠道,请使用积分或联系管理员配置支付。',
      realHint: '请在新打开的收银台完成支付,支付成功后将自动开通订阅。',
      openPayWindow: '打开支付页面',
      waitingPaid: '正在等待支付结果…',
    },
  },
  storage: {
    title: '对象存储',
    subtitle: '管理租户云存储配额，并配置自有 OSS/COS（供制片项目选用）。',
    usage: '已用空间',
    freeIncluded: '含免费 {{n}}',
    addonIncluded: '扩容 {{n}}',
    available: '剩余可用 {{n}}',
    activeAddons: '生效中的扩容',
    expires: '到期 {{date}}',
    tabs: {
      aria: '对象存储分区',
      aliyun: '阿里云',
      tencent: '腾讯云',
      plans: '扩容套餐',
      activeHint: '使用中',
    },
    custom: {
      title: '自有对象存储',
      hint: '每位用户一套阿里云 OSS / 腾讯云 COS 凭据。创建制片项目选择「自有对象存储」时将使用此配置（快照到项目，不占用租户存储配额）。',
      providerTitle: '{{provider}} 对象存储',
      providerHint: '保存前会探测 Bucket 读写权限；Secret 不会在界面回显。每位用户仅保留一套配置，保存将覆盖另一厂商的旧配置。',
      notConfigured: '当前尚未配置此云厂商。填写后保存即可用于新建制片项目。',
      otherProviderActive: '当前生效的是「{{provider}}」。在此保存将切换为当前云厂商配置。',
      configuredSummary: '已配置：{{provider}} · Bucket {{bucket}} · Region {{region}}',
      save: '保存配置',
      clear: '清除配置',
      saveSuccess: '自有对象存储已保存',
      clearSuccess: '已清除自有对象存储配置',
      loadFailed: '加载自有对象存储失败',
      saveFailed: '保存自有对象存储失败',
      clearFailed: '清除自有对象存储失败',
      notConfiguredError: '请先在用户中心配置自有对象存储',
    },
    plansTitle: '扩容套餐',
    plansHint: '购买后立即增加可用空间,到期后扩容失效;已上传文件保留,若超出免费额度需清理或续购。',
    billingCycle: {
      monthly: '包月',
      quarterly: '包季',
      yearly: '包年',
    },
    pricePeriod: {
      monthly: '/月',
      quarterly: '/季',
      yearly: '/年',
    },
    loginHint: '登录后查看对象存储用量与扩容套餐',
    noPlansForCycle: '该周期暂无可用套餐',
    days: ' 天',
    pricePoints: '{{n}} 积分{{period}}',
    priceCash: '¥{{n}}{{period}}',
    buy: '立即购买',
    purchaseSuccess: '已开通「{{plan}}」,空间已扩容',
    footerHint: '也可开通会员获取积分,用于支付扩容:',
    subscriptionLink: '会员订阅',
    pay: {
      title: '购买 {{plan}}',
      amount: '应付',
      pointsAmount: '{{n}} 积分',
      cashAmount: '¥ {{n}}',
      balance: '当前积分余额 {{n}}',
      method: '支付方式',
      points: '积分支付',
      channelAlipay: '支付宝',
      channelWechat: '微信支付',
      channelPayPal: 'PayPal',
      confirm: '确认支付',
      channelUnavailable: '该支付渠道未配置,请在管理端配置支付宝/微信/PayPal 密钥,或使用积分支付。',
      noChannels: '暂无可用支付渠道,请使用积分或联系管理员配置支付。',
      realHint: '请在新打开的收银台或扫码完成支付,支付成功后将自动扩容。',
      openPayWindow: '打开支付页面',
      waitingPaid: '正在等待支付结果…',
      pointsInsufficient: '积分不足,请先签到或充值',
    },
  },
  tipDialog: {
    title: '打赏「{{title}}」',
    balance: '可打赏 {{n}} · 促销 {{promo}} · 合计 {{total}} 积分',
    pickAmount: '选择积分',
    customPlaceholder: '或自定义积分',
    messageLabel: '留言(可选)',
    messagePlaceholder: '给作者一句鼓励吧…',
    breakdown: '支付 {{amount}} 积分 · 平台抽成 {{fee}} · 作者实得 {{earn}}',
    insufficient: '可打赏积分不足。促销积分仅可用于 AI 等消费，充值或收益兑换后可打赏。',
    confirm: '确认打赏',
    submitting: '提交中…',
    minAmount: '请输入大于 0 的积分数',
  },
  workDetail: {
    backToGallery: '作品广场',
    notFound: '作品不存在或对您不可见。',
    noEpisode: '尚未添加分集',
    noVideo: '该分集暂无视频',
    publishedAt: '发布于 {{date}}',
    author: '作者 #{{n}}',
    fingerprint: '版权指纹 · {{hash}}',
    support: '支持作者',
    tipCount: '已收到 {{n}} 次打赏',
    tipSelf: '不能给自己打赏',
    tipCta: '用积分打赏作者',
    tipLoginRequired: '登录后打赏',
    tipHint: '打赏走积分钱包,平台抽成 10%,其余进入作者收益账户。',
    episodes: '分集({{n}})',
    noEpisodes: '暂无分集',
    moreInfo: '作品说明',
    stat: {
      episodes: '分集',
      published: '发布日期',
    },
    process: {
      title: '制作过程',
      canvas: '画布预览',
      assets: '资产预览',
      source: '来源画布',
      empty: '作者未公开制作过程（仅自由创作发布的作品可预览与复刻）。',
      noAssets: '暂无可预览资产',
      copy: '复制到我的创作',
      copyOk: '已复制到我的创作',
      loginHint: '登录后可将本项目复刻到你的自由创作画布。',
      readOnlyHint: '只读画布预览，可缩放平移查看节点，不可编辑。',
    },
  },
  home: {
    titleSuffix: 'AI 漫剧工作台',
    intro: 'AI 漫剧创作平台 · 国际赛事 · 平台内版权登记。',
    welcome: '欢迎回来,<1>{{user}}</1>。',
    guestHint: '未登录用户可浏览作品与赛事,工作台、版权与收益功能需要登录。',
    enterProjects: '进入工程',
    browseWorks: '浏览{{title}}',
    navTitle: '快捷入口',
    hero: {
      badge: 'International · 开放赛事',
      title: '加入全球 AI 创意革命',
      subtitle:
        '连接全球数百万创作者,将文字转化为电影级漫剧,参与国际赛事,在世界舞台展示你的作品。',
      ctaCreate: '开始创作',
      ctaExplore: '探索全球热门作品',
    },
    announcement: {
      remaining: '活动剩余 {{days}}天 {{hours}}时 {{minutes}}分 {{seconds}}秒',
      label: '活动剩余',
      days: '天',
      hours: '时',
      minutes: '分',
      seconds: '秒',
    },
    carousel: {
      prev: '上一张',
      next: '下一张',
      play: '播放',
      pause: '暂停',
      goTo: '第 {{n}} 张',
      seasonEnded: '赛季已截止',
      countdownDays: '距截止 {{days}} 天 {{hours}} 小时',
      countdownHours: '距截止 {{hours}} 小时 {{mins}} 分',
      topRanking: 'TOP 榜单',
      votesUnit: '票',
      contestFallback: '国际 AI 漫剧开放赛,混合评审,全球创作者同台竞技',
      workFallback: '来自全球创作者的精选 AI 漫剧作品',
      badges: {
        contest: '全球赛事',
        featured: '全球精选',
      },
      fallback: {
        slide1: {
          title: '加入全球 AI 创意革命',
          subtitle:
            '连接全球数百万创作者,将文字转化为电影级漫剧,参与国际赛事,在世界舞台展示你的作品。',
        },
        slide2: {
          title: '霓虹之夜 · 全球创意赛',
          subtitle: '持续开放的国际 AI 漫剧赛事,混合评审,奖金池以 USD 等值展示,随时报名。',
        },
        slide3: {
          title: '从剧本到成片,一站完成',
          subtitle: '多语言剧本、角色一致性、场景生成与自动合成,助力你的作品走向全球。',
        },
      },
    },
    stats: {
      countries: '覆盖国家/地区',
      countriesValue: '48+',
      creators: '全球创作者',
      creatorsValue: '50 000+',
      contests: '进行中赛事',
      works: '公开作品',
    },
    contests: {
      title: '全球创意大赛',
      subtitle: '持续开放的国际 AI 漫剧赛事,混合评审,奖金以 USD 等值展示',
      enter: '立即参赛',
      prizeUsd: '≈ {{amount}} USD',
      prizePoints: '{{n}} 积分奖池',
      viewAll: '查看全部赛事',
      empty: '暂无进行中的赛事,敬请期待',
    },
    features: {
      title: 'AI 能力',
      subtitle: '剧本 · 角色 · 场景 · 合成，一站式 AI 漫剧创作流水线',
      viewAll: '查看全部能力',
      backHome: '返回首页',
      script: {
        title: '剧本生成',
        desc: 'AI 辅助分镜与对白,多语言剧本一键生成',
      },
      character: {
        title: '角色一致性',
        desc: '跨镜头保持角色形象统一,适配国际风格',
      },
      scene: {
        title: '场景生成',
        desc: '赛博朋克、奇幻、写实…全球视觉风格任选',
      },
      compose: {
        title: '自动合成',
        desc: '音画自动对齐,一键导出参赛与发布规格',
      },
      capability: {
        title: 'AI 能力',
        desc: '面向漫剧创作的多模态 AI 能力，按需扩展与组合',
      },
      mock: {
        newScript: '新建脚本',
        type: '类型',
        typeVal: '科幻',
        lang: '语言',
        langVal: '中文',
        scriptText: '场景一：星际联邦舰队缓缓进入画面，少年指挥官站在舰桥中央…',
        storyboard: '分镜建议',
        shot1: '全景 · 星际联邦舰队缓缓进入画面…',
        shot2: '中景 · 舰桥内，少年指挥官…',
        charLib: '角色库',
        myChars: '我的角色',
        similarity: '相似度',
        styleMatch: '风格一致性',
        sceneLib: '场景库',
        myScenes: '我的场景',
        scene1: '未来都市',
        scene2: '古风庭院',
        scene3: '赛博空间',
        scene4: '雪山峰岭',
        cameraCtrl: '镜头控制',
        perspective: '虚化强度',
        composing: '合成中… 68%',
        composeNote1: '最终渲染，请耐心等待。',
        composeNote2: '数据同步中，请勿关闭页面。',
        sub1: '星际边缘，希望仍在。',
        sub2: '指挥官，前方发现未知信号。',
        aiBadge: 'AI',
        aiTitle: 'AI 能力引擎',
        aiPrompt: '输入创意意图，多模态模型协同生成漫剧资产',
        powerTitle: '能力加速',
        powerPrompt: '批处理与低延迟推理，支撑高并发创作',
        stepUnderstand: '理解',
        stepGenerate: '生成',
        stepPolish: '精修',
        stepReady: '就绪',
        stepBoost: '加速',
        stepDeliver: '交付',
        chipText: '文生剧本',
        chipImage: '文生图',
        chipVideo: '文生视频',
        chipLocale: '多语言',
        chipSpeed: '低延迟',
        chipBatch: '批处理',
        chipQuality: '高保真',
        confidence: '生成置信度',
        throughput: '吞吐负载',
      },
    },
    gallery: {
      title: '全球精选作品',
      subtitle: '按地区浏览社区热门 AI 漫剧,发现跨文化创意',
      viewAll: '查看全部',
      regions: {
        global: '全球',
        zh: '中国',
        en: '英语区',
        fr: '法国',
        de: '德国',
        es: '西语区',
        pt: '葡语区',
        it: '意大利',
        id: '印尼',
        ko: '韩国',
        ja: '日本',
        ar: '阿拉伯',
      },
      badges: {
        hot: '热门',
        top: '精选',
        pinned: '置顶',
      },
      empty: '该地区暂无作品,看看全球热门吧',
      views: '{{n}} 浏览',
      featuredBadge: '本周精选',
      soundOn: '开启声音',
      soundOff: '关闭声音',
      fullscreen: '全屏播放',
      videoLoading: '视频加载中',
      demoTitle: '星际边缘：希望之光',
      demoDesc: '在浩瀚宇宙的边缘，一群探索者寻找文明的曙光。',
      demoCreator: 'NovaVision',
      positiveReviews: '98% 好评',
    },
    platform: {
      title: '平台数据',
      moreData: '更多数据 ›',
      works: '总作品数',
      satisfaction: '用户满意度',
      countries: '覆盖国家',
      creators: '活跃创作者',
      tags: '热门标签',
    },
    entries: {
      myProjects: { title: '我的作品', desc: '管理草稿、提交审核与发布。' },
      works: { title: '作品广场', desc: '浏览社区已发布的 AI 漫剧短片' },
      contests: { title: '赛事中心', desc: '报名国际 AI 漫剧赛事,赢取奖金与积分' },
      myWorks: { title: '我的作品', desc: '查看自己已投稿、已发布、收益记录' },
      copyright: { title: '版权登记', desc: '为已发布作品申请平台内版权证书' },
    },
  },
  creator: {
    title: '创作者主页',
    notFound: '找不到该创作者',
    profile: {
      worksCount: '作品 {{n}}',
      totalViews: '总浏览 {{n}}',
      totalLikes: '总点赞 {{n}}',
      contestAwards: '赛事获奖 {{n}}',
      copyrightCount: '版权登记 {{n}}',
      listingCount: '在售 {{n}}',
      memberSince: '加入于 {{date}}',
      followers: '{{n}} 粉丝',
      following: '关注 {{n}}',
      aboutTitle: '关于创作者',
      bioTitle: '简介',
      noBio: '这位创作者还没有填写简介',
      socialTitle: '社交外链',
    },
    follow: '关注',
    unfollow: '已关注',
    share: '分享',
    shareCopied: '链接已复制',
    badges: {
      member: '会员',
      platformVerified: '官方认证创作者',
      realnameVerified: '已实名',
    },
    report: '举报',
    reportTitle: '举报该创作者',
    reportHint: '我们会审核你的举报，请尽量描述具体情况',
    reportReasonLabel: '举报原因',
    reportReason: {
      spam: '垃圾信息 / 广告',
      abuse: '骚扰 / 不当内容',
      impersonation: '冒充他人',
      other: '其他',
    },
    reportDetailPlaceholder: '补充说明（可选）',
    reportSubmit: '提交举报',
    reportSuccess: '举报已提交，感谢反馈',
    featuredWorks: '代表作',
    contestRank: '第 {{n}} 名',
    sort: {
      label: '作品排序',
      publishedAt: '最新发布',
      views: '最多浏览',
      likes: '最多点赞',
      createdAt: '最近创建',
    },
    tabs: {
      works: '作品',
      contests: '赛事成就',
      copyrights: '版权登记',
      listings: '交易中心',
      about: '关于',
    },
    empty: '该创作者还没有公开作品',
    emptyContests: '暂无赛事获奖记录',
    emptyCopyrights: '暂无公开版权登记',
    emptyListings: '暂无在售挂牌',
    visitWork: '查看作品',
    workPreview: {
      title: '作品预览',
      loading: '加载作品中…',
      noVideo: '暂无视频，可查看封面或进入完整播放页',
      openFull: '完整播放',
    },
  },
  works: {
    title: '作品广场',
    subtitle: '社区已发布的 AI 漫剧短片',
    filterAll: '全部',
    creator: '创作者',
    views: '浏览',
    likes: '点赞',
    tipBtn: '打赏',
    viewDetail: '查看详情',
    noSummary: '(无简介)',
    empty: '暂无作品',
    viewProcess: '查看制作过程',
  },
  accountWorks: {
    title: '我的作品',
    subtitle: '审核、发布与下架；从创作中心「发布到作品」同步后可在此管理。',
    filter: {
      all: '全部',
      status: '状态',
    },
    empty: '还没有作品',
    emptySub: '在创作中心画布完成 AI 片段后，通过「发布到作品」同步到此管理、审核与上架。',
    goStudio: '去创作中心',
    row: {
      noSummary: '(无简介)',
      meta: '创建于 {{date}} · 浏览 {{views}}',
      preview: '预览',
      edit: '编辑',
      submitReview: '提交审核',
      publish: '发布',
      offline: '下架',
      delete: '删除',
      deleteConfirm: '确认删除「{{title}}」?',
    },
    edit: {
      back: '我的作品',
      title: '编辑作品',
      notFound: '作品不存在',
      basic: {
        title: '基本信息',
        labels: {
          title: '标题',
          summary: '一句话简介',
          description: '详情(Markdown)',
          coverUrl: '封面',
          tags: '标签(逗号分隔)',
          tagsPh: '赛博朋克, 科幻',
          visibility: '可见性',
        },
        visibility: {
          public: '公开 public',
          unlisted: '不公开 unlisted',
          private: '仅自己 private',
        },
        save: '保存',
        saving: '保存中…',
        savedAt: '已保存 · {{time}}',
      },
      episodes: {
        title: '分集({{n}})',
        ep: '分集标题',
        videoUrl: '视频 URL(可选)',
        duration: '时长(秒)',
        add: '添加',
        empty: '至少需要 1 个分集才能发布作品。',
        meta: '{{n}}s · {{video}}',
        noVideo: '无视频',
        publish: '发布',
        offline: '下架',
        delete: '删除',
        deleteConfirm: '确认删除该分集?',
      },
    },
  },
  withdrawals: {
    title: '提现',
    subtitle:
      '把可用收益变成现金：从收益直接提现，或先把积分换现金(1 积分 = ¥0.01，起提 100 积分)。',
    backToRevenue: '我的收益',
    applyPoints: '申请积分提现',
    applyCash: '申请现金提现',
    empty: '还没有提现记录',
    cancelConfirm: '确认撤销该笔提现申请?锁定的金额 / 积分会原路退回。',
    table: {
      time: '申请时间',
      method: '方式',
      amount: '金额',
      status: '状态',
      note: '说明',
      action: '操作',
    },
    status: {
      pending: '待审批',
      approved: '审批通过',
      paid: '已打款',
      rejected: '已驳回',
      canceled: '已撤销',
    },
    methodCashEntries: '现金 · {{n}} 笔',
    methodPoints: '积分换现金',
    deductPoints: '- {{n}} 积分',
    cancel: '撤销',
    note: {
      pending: '等待管理员审批',
      approved: '审批通过,等待打款',
      canceled: '已撤销',
      paidNote: '流水 {{note}}',
    },
    cash: {
      title: '现金提现申请',
      subtitle: '仅可选「可用 + 有现金金额」的收益记录，所选金额 ≥ ¥100 才能提交。',
      loadingRecords: '加载收益记录…',
      noRecord: '没有可提现的收益。打赏 / 兑换 / 赛事奖金到账后才会出现。',
      selectedSummary: '已选 {{count}} 笔 · 合计 ¥{{total}}',
      belowMin: '(未达 ¥100 起提)',
      bankPh: '开户行(如:招商银行 北京分行)',
      namePh: '收款人姓名',
      accountPh: '收款账号(银行卡号 / 支付宝账号)',
      errMin: '提现起步 ¥100,请多选几笔',
      errSelect: '请至少选择一条收益记录',
      errAccount: '请完整填写收款人信息',
      submit: '提交申请',
    },
    points: {
      title: '积分提现',
      subtitle: '1 积分 = ¥0.01,起提 100 积分。可打赏积分 {{balance}}（促销积分不可提现）',
      pointsLabel: '提现积分',
      gain: '可获得 ¥{{cny}} 现金',
      namePh: '收款人姓名(需匹配支付宝实名)',
      alipayPh: '支付宝账号(手机号 / 邮箱)',
      errMin: '起提 100 积分',
      errInsufficient: '可打赏积分不足（促销积分不可提现）',
      errAccount: '请填写收款人姓名 + 支付宝账号',
      submit: '提交申请',
    },
  },
  copyright: {
    title: '版权中心',
    subtitle: '为已发布作品申请平台内版权证书 · SHA-256 指纹 + UTC 时间戳 + 可下载 PDF。',
    needLogin: '请先登录后再使用版权登记。',
    register: {
      title: '申请版权登记',
      feeHint: '每条登记费用 200 积分。仅支持已发布作品,系统会生成证书号与可下载的 PDF 证书。',
      pickWork: '选择作品(仅显示「已发布且未登记」)',
      pickWorkPlaceholder: '— 请选择 —',
      loadingWorks: '加载作品中…',
      noEligible: '没有可登记的已发布作品。',
      goPublish: '去发布',
      authorName: '作者署名(可选,默认昵称)',
      authorPlaceholder: '留空 = 使用昵称',
      submit: '提交登记(-200 积分)',
    },
    list: {
      title: '我的版权登记',
      count: '{{n}} 条',
      empty: '还没有版权登记。',
      revoked: '已撤销',
      certNo: '证书号 · {{no}}',
      fp: 'fp · {{hash}}',
      authorAndDate: '作者 {{author}} · 登记于 {{date}}',
      downloadPdf: '下载 PDF',
      downloading: '下载中…',
      verifyLink: '验真链接',
    },
    verify: {
      back: '我的版权',
      title: '证书验真',
      verifying: '验证中…',
      valid: '有效',
      revoked: '已撤销',
      certNo: '证书号 {{no}}',
      kv: {
        author: '作者',
        category: '分类',
        registeredAt: '登记时间(UTC)',
        fee: '平台费用(积分)',
        fingerprint: '指纹(SHA-256)',
        summary: '摘要',
      },
      footer: '本证书由 SilkReels 平台内部存证生成,不替代官方版权局登记。public_id · {{pid}}',
    },
  },
  learning: {
    title: '学习中心',
    subtitle: '视频教程与创作指南 · 免费观看或积分解锁',
    emptyList: '暂无教程',
    noSummary: '(无简介)',
    loginHintTitle: '登录后可解锁付费教程',
    loginHintDesc: '免费教程无需登录；付费内容需登录并使用积分解锁。',
    backToList: '返回教程列表',
    episodeCount: '{{count}} 集',
    pricingFree: '免费',
    pricingPaid: '整系列 {{points}} 积分',
    pricingMixed: '前 {{count}} 集免费',
    episodesTitle: '分集 ({{n}})',
    episodeNo: '第 {{no}} 集',
    play: '播放',
    unlockEpisode: '解锁 {{points}} 积分',
    unlockAll: '解锁全系列',
    unlockAllTitle: '解锁全部付费分集',
    unlockAllDesc: '一次支付 {{points}} 积分解锁剩余全部内容',
    selectEpisodeHint: '选择分集并点击播放',
    nowPlaying: '正在播放',
    notFound: '教程不存在或已下架',
    stat: {
      episodes: '分集',
      pricing: '定价',
      freeEpisodes: '免费集数',
      unlockPoints: '解锁积分',
    },
  },
  contests: {
    title: '赛事中心',
    subtitle: '国际 AI 漫剧持续开放赛 · 大众投票 + 专家评审混合制。',
    emptyList: '还没有公开赛事。',
    guestHint: '登录后即可投稿和投票。',
    guestHintTitle: '登录解锁更多赛事能力',
    backToList: '赛事列表',
    notFound: '赛事不存在。',
    noDescription: '(无描述)',
    noSummary: '(无简介)',
    noCover: '无封面',
    code: '编码 {{code}}',
    entryFee: '报名费 {{n}} 积分',
    rewardPool: '奖池 {{n}} 积分',
    submissionDue: '投稿截止 {{date}}',
    filterAll: '全部状态',
    points: '{{n}} 积分',
    submit: '投稿',
    needLogin: '请先登录',
    notOpenSubmit: '赛事不在投稿期',
    notVoting: '不在投票期',
    tabs: {
      latest: '最新',
    },
    status: {
      draft: '筹备中',
      open: '投稿中',
      voting: '投票中',
      judging: '评审中',
      closed: '已结束',
    },
    stat: {
      entryFee: '报名费',
      reward: '奖池',
      entries: '投稿数',
      status: '状态',
    },
    detail: {
      overview: '赛事说明',
      schedule: '赛程',
      scheduleRange: '开赛至收官',
      scheduleSubmitDue: '投稿截止',
      scheduleVoteDue: '投票截止',
      workAbout: '作品简介',
      authorAbout: '作者简介',
      noWorkAbout: '暂无作品简介',
      noAuthorAbout: '这位创作者还没有填写简介',
      noEntrySelected: '选择一件参赛作品查看简介',
      authorFallback: '创作者 #{{id}}',
    },
    entries: {
      title: '参赛作品',
      empty: '暂无审核通过的作品。',
      votes: '票数 {{n}}',
      judgeAvg: '评审均分 {{n}}',
      view: '查看作品',
      vote: '投我一票',
      voting: '投票中…',
      review: {
        pending: '审核中',
        approved: '已通过',
        rejected: '未通过',
      },
    },
    entryPreview: {
      title: '作品预览',
      loading: '加载作品中…',
      noVideo: '暂无视频，可查看封面或进入完整播放页',
      openFull: '完整播放',
      openExternal: '打开外链',
      externalHint: '该投稿为外部链接，点击下方按钮在新标签页打开。',
    },
    submitDialog: {
      title: '投稿至「{{title}}」',
      feeHint: '报名费 {{n}} 积分,提交后将自动扣除。',
      pickWork: '选择我的已发布作品(推荐)',
      noBind: '— 不绑定(改用外链投稿) —',
      titleLabel: '展示标题(可选,默认作品标题)',
      titlePlaceholder: '可留空自动取作品标题',
      descLabel: '简介(可选)',
      urlLabel: '外链 URL(work_id 为空时必填)',
      urlPlaceholder: 'https://… 或 silkreels://work/<public_id>',
      coverLabel: '封面(可选)',
      confirm: '确认投稿',
      successPending: '投稿已提交，等待管理员审核通过后会在本页展示。',
    },
    errors: {
      submitFailed: '投稿失败，请稍后重试。',
      alreadySubmitted: '你已在本赛事投过稿，每人每赛只能提交一次。作品经管理员审核通过后，会在左侧列表公开展示。',
      alreadySubmittedApproved: '你已在本赛事投稿，审核已通过，作品在左侧公开展示。',
      alreadySubmittedRejected: '你的投稿未通过审核。{{reason}}',
      contestClosed: '赛事当前不在投稿期，暂无法提交。',
      workNotPublished: '请选择「已发布」的作品，或先到「我的作品」完成发布。',
      workNotOwned: '只能投稿属于你自己的作品。',
      workNotFound: '关联作品不存在或已删除。',
      insufficientPoints: '积分不足，无法支付报名费。',
      votingClosed: '当前不在投票期。',
      judgingClosed: '当前不在评审期。',
      entryNotApproved: '该作品尚未通过审核，暂不能投票或评分。',
      alreadyVoted: '你已在本赛事投过票，每人仅限一票。',
      voteIpBlocked: '当前网络投票过于频繁，请稍后再试。',
      voteFailed: '投票失败，请稍后重试。',
    },
    alreadySubmittedHint: '已投稿，等待审核',
    submittedApproved: '已投稿，审核通过',
    submittedRejected: '投稿未通过',
    withdraw: '退出赛事',
    withdrawing: '退赛中…',
    withdrawTitle: '确认退赛',
    withdrawConfirm: '确认退出「{{title}}」？退赛后投稿将被删除；若曾支付报名费，将退还 {{n}} 积分。',
    withdrawSuccess: '已退赛，报名费已退还（如有）。',
    withdrawFailed: '退赛失败，请稍后重试。',
    withdrawNotOpen: '赛事已进入投票或评审阶段，无法退赛。',
    seasons: {
      sectionTitle: '赛季 / 出榜',
      count: '{{n}} 个赛季',
      loading: '正在加载赛季…',
      loadError: '加载赛季失败:{{msg}}',
      empty: '本赛事还没有出榜赛季 / 周榜,新作品按整体投稿展示。',
      pendingSettle: '赛季尚未出榜,出榜后将公示排行与发奖名单。',
      rankLoading: '加载排行中…',
      rankEmpty: '本赛季没有发奖记录。',
      rankRow: 'entry-{{id}}',
      reward: '+{{n}} 积分',
      status: {
        open: '收稿中',
        judging: '评审中',
        settled: '已出榜',
        archived: '已归档',
      },
    },
  },
  feedback: {
    pageTitle: '反馈中心',
    pageSubtitle: '提交 Bug、产品建议或体验问题；审核通过后可获得积分奖励',
    newFeedback: '提交反馈',
    empty: '还没有反馈记录，欢迎告诉我们你的使用体验',
    totalCount: '共 {{n}} 条',
    listHint: '点击条目查看详情',
    reviewNote: '平台回复',
    submittedAt: '提交于',
    reviewedAt: '审核于',
    pageUrl: '相关页面',
    attachments: '附件',
    playVideo: '播放视频',
    rewardGranted: '审核通过，已奖励 {{points}} 积分',
    dialogTitle: '提交反馈',
    dialogSubtitle: '描述问题或建议；审核通过将发放积分奖励',
    rewardBannerTitle: '有效反馈可获积分奖励',
    rewardBannerSelected: '当前类型审核通过约 +{{points}} 积分',
    rewardBannerMax: 'Bug 反馈最高约 +{{points}} 积分（以平台审核为准）',
    rewardHint: '审核通过约 +{{points}} 积分',
    floatLabel: '帮助与反馈',
    floatFeedback: '反馈中心',
    floatSupport: '客服中心',
    floatDragHint: '拖动可移动位置',
    csComingSoon: '在线客服即将上线，请先通过反馈中心联系我们',
    supportDialog: {
      subtitle: '可通过以下方式联系我们',
      phone: '客服电话',
      email: '客服邮箱',
      qrcode: '客服二维码',
      loading: '正在加载客服信息…',
      empty: '暂未配置客服联系方式，请稍后再试或通过反馈中心留言',
    },
    viewHistory: '查看我的反馈',
    dashboardLink: '查看我的反馈记录与审核进度',
    categoriesShort: {
      bug: 'Bug',
      suggestion: '建议',
      experience: '体验',
      other: '其他',
    },
    categories: {
      bug: 'Bug / 故障',
      suggestion: '产品建议',
      experience: '体验问题',
      other: '其他',
    },
    status: {
      pending: '待审核',
      rewarded: '已奖励',
      rejected: '未通过',
    },
    form: {
      category: '反馈类型',
      title: '标题（可选）',
      titlePlaceholder: '一句话概括问题',
      content: '详细说明',
      contentPlaceholder: '请描述复现步骤、期望行为或改进建议…',
      contentRequired: '请填写反馈内容',
      attachments: '截图 / 视频',
      attachHint: '上传截图或录屏，最多 4 个，便于快速定位问题',
      addMedia: '添加',
      maxAttachments: '最多上传 {{n}} 个附件',
      invalidMedia: '仅支持图片或视频',
      waitUpload: '请等待附件上传完成',
      submit: '提交反馈',
      submitSuccess: '反馈已提交，感谢你的帮助！',
    },
  },
  messages: {
    title: '消息中心',
    subtitle: '协作通知、任务进度与反馈审核结果',
    bellLabel: '消息通知',
    empty: '暂无消息',
    unread: '未读',
    unreadCount: '{{count}} 条未读',
    viewAll: '查看全部消息',
    markAllRead: '全部标为已读',
    markReadFailed: '标记已读失败',
    markAllFailed: '全部已读失败',
    loadMore: '加载更多',
    filters: {
      all: '全部',
      unread: '未读',
    },
    categories: {
      all: '全部分类',
      studio: '创作协作',
      task: '任务中心',
      account: '账户与反馈',
      system: '系统',
    },
  },
}
